// Politika izrazoslovja (§9.5): Traefikovi domenski izrazi — router, service, middleware,
// entrypoint, resolver, snapshot, group, certResolver — ostanejo v ANGLEŠČINI v obeh jezikih.
// Polprevedeno infrastrukturno izrazje je za bralce Traefikove dokumentacije slabše od izvirnika.
//
// Isto pravilo velja za „static config“: Traefikova dokumentacija deli konfiguracijo na *static*
// in *dynamic*, in prav s tema besedama operater išče to, kar ta panel ureja.
export default {
    general: {
        add:     'Dodaj',
        edit:    'Uredi',
        cancel:  'Prekliči',
        save:    'Shrani',
        delete:  'Izbriši',
        close:   'Zapri',
        confirm: 'Potrdi',
        back:    'Nazaj',
        search:  'Iskanje',
        yes:     'Da',
        no:      'Ne',
        actions: 'Dejanja',
        replace: 'Zamenjaj',
        loading: 'Nalaganje…',
        no_data: 'Ni podatkov',
        email:   'E-pošta',
        created: 'Ustvarjeno',
        updated: 'Posodobljeno',
        none:    'Brez',
        // Oznaka ob straničenju na strani odjemalca. Skupna, ne po zaslonih (W12.5): tabele
        // runtima in seznam groupov rišejo isto straničenje po petdeset in ga ne smejo poimenovati
        // vsak po svoje.
        page_range: '{from}–{to} od {total}',
    },
    // Bere jih hišna lupina (vue-spec templates/shell): vrstica z znamko v stranski vrstici.
    brand: {
        product_name: 'Traefik Proxy Manager',
        tagline:      'Konzola flote',
    },
    nav: {
        dashboard:           'Nadzorna plošča',
        issues:              'Težave',
        instances:           'Instance',
        clients:             'Stranke',
        registry:            'Register',
        users:               'Uporabniki',
        profile:             'Profil',
        navigation:          'Navigacija',
        language:            'Jezik',
        search_hint:         'Skok na instanco, stranko ali zaslon.',
        sign_out:            'Odjava',
        // D78 — velja samo znotraj TPM: vse seje klicatelja v Traefik Proxy Managerju, na vseh
        // napravah. Nikoli ne poseže v prijavo IT Team ID ali v drugo aplikacijo; oznaka ta obseg
        // poimenuje, da se nikoli ne bere kot globalna odjava (primopredaja §7.1).
        sign_out_all_tpm:    'Odjava iz vseh sej TPM',
        // Naslovi skupin v stranski vrstici (`layouts/layout.ts` → NAV_GROUPS).
        group_fleet:         'Flota',
        group_system:        'Sistem',
    },
    // Oba gumba mobilnega predala (templates/shell).
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    // Dvostanjski preklopnik barvnega načina v zgornji vrstici (theme.md): opis ob gumbu poimenuje
    // način, NA katerega klik preklopi. Samo svetli in temni — sistemske možnosti ni.
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    auth: {
        sign_in:        'Prijava',
        sign_in_with:   'Prijava z IT Team ID',
        sign_in_hint:   'Preusmerjeni boste na ponudnika identitete vašega podjetja.',
        signing_in:     'Prijavljanje…',
        signed_in_as:   'Prijavljeni kot {email}',
        account:        'Račun',
        no_access_title: 'Dostop še ni dodeljen',
        // §10.2 — natančno besedilo za uporabnika brez vloge in brez dodelitev.
        no_access:      'Vaš račun je bil ustvarjen. Za dostop se obrnite na administratorja.',
        check_again:    'Preveri znova',

        // F36 — pogodba neuspešne prijave: neuspešen povratni klic preusmeri na
        // /login?reason=<koda>, spodnjih pet sporočil pa vsako kodo pojasni. Nabor se ujema s
        // konstantami loginReason* v tpm-api (HTTP_API/Authentication.go); neznana koda se
        // izriše kot sign_in_failed, surova vrednost iz naslova pa se nikoli ne prikaže.
        login_failed: {
            title:          'Prijava ni uspela',
            idp_refused:    'Ponudnik identitete je prijavo zavrnil — vaš račun nima dostopa do tega portala. Obrnite se na administratorja.',
            state_mismatch: 'Poskus prijave je potekel ali se ni ujemal. Začnite znova.',
            incomplete:     'Prijava ni bila dokončana. Začnite znova.',
            not_allowed:    'Vaša identiteta je bila potrjena, vendar ta račun nima dostopa do tega portala. Obrnite se na administratorja.',
            sign_in_failed: 'Prijava ni uspela. Poskusite znova; če se težava ponavlja, se obrnite na administratorja.',
        },

        // D78 — stran po odjavi je /login?signed_out=<stanje>, spodnja sporočila pa stanje pojasnijo.
        // Obe potrjeni odjavi veljata samo za Traefik Proxy Manager: prijava IT Team ID ostane
        // nedotaknjena, zato Prijava morda ne bo zahtevala gesla. `unconfirmed` pomeni, da je
        // piškotek odstranjen, strežnik pa ni mogel potrditi, da je bil zapis seje končan.
        signed_out_title:       'Odjavljeni',
        signed_out_device:      'Na tej napravi ste odjavljeni iz Traefik Proxy Managerja. Vaša prijava v IT Team ID ni prizadeta, zato Prijava morda ne bo zahtevala gesla.',
        signed_out_all:         'Odjavljeni ste iz vseh svojih sej Traefik Proxy Managerja na vseh napravah. Vaša prijava v IT Team ID ni prizadeta.',
        signed_out_unconfirmed: 'Sejni piškotek je bil odstranjen, vendar strežnik ni mogel potrditi, da je bila seja končana. Prijavite se in uporabite »Odjava iz vseh sej TPM« ali poskusite znova pozneje.',
    },
    // Vstopni pogled (§7.1). Vsaka ploščica vodi na seznam, nad katerim je bila njena številka
    // preštetá, zato si nikoli ne moreta nasprotovati; katere so filtrirane in zakaj druge niso,
    // pojasnjuje `libs/dashboard.ts`.
    dashboard: {
        fleet:            'Flota',
        needs_attention:  'Zahteva pozornost',
        all_clear:        'Nič ne zahteva pozornosti',
        all_clear_hint:   'Med instancami, ki jih vidite, ni odprtih težav.',
        view_all:         'Vse težave',
        more_issues:      'Prikaz: {shown} od {total} — poglej vse',
        panel_version:    'Panel v{version}',
        refresh_failed:   'Osvežitev ni uspela',

        tiles: {
            instances:       'Instance',
            offline:         'Nedosegljive',
            offline_hint:    'Odpre nedosegljive lokacije',
            open_issues:     'Odprte težave',
            critical_issues: 'Kritične',
            clients:         'Stranke',
            groups:          'Skupine',
            groups_hint:     'Skupine živijo znotraj instance',
        },

        split: {
            healthy:      'Zdrave',
            degraded:     'Okrnjene',
            offline:      'Nedosegljive',
            pending:      'V čakanju',
            // Pravilo iz §9.5, zapisano tam, kjer je številka: lokacija, ki se še ni nikoli
            // javila, ni izpadla.
            pending_hint: 'V čakanju pomeni, da se lokacija še ni nikoli javila — ustvarjena je, a še ni nameščena. To ni izpad.',
        },
    },
    // Težave iz §7.1 in izrisovalnik iz §9.5. Spodnjih šestnajst vnosov `issues.<type>` so
    // predloge sporočil: strežnik pošlje `type` in `params{}`, SPA pa izriše
    // `t('issues.' + type, params)`, zato vsak nadomestni znak spodaj poimenuje parameter, ki ga
    // `Logic/IssueRules.go` resnično pošilja. Sedemnajsta vrsta pomeni dva vnosa tu in dva v
    // en.ts — `yarn check:i18n` pade v trenutku, ko manjka katera koli polovica.
    issues: {
        title:          'Težave',
        issue:          'Težava',
        severity_label: 'Resnost',
        since_label:    'Odprto že',
        since:          'že {ago}',
        open:           'Odpravi',
        open_hint:      'Odpre zavihek, kjer to odpravite',
        critical_open:  'Kritične: {count}',

        severity: {
            critical: 'Kritično',
            warning:  'Opozorilo',
        },

        // Kratko ime vrste — samo za možnosti filtra. Traefikovi izrazi ostajajo v angleščini,
        // tako kot povsod (glej glavo datoteke).
        types: {
            host_cpu:                    'CPU gostitelja',
            host_memory:                 'Pomnilnik gostitelja',
            host_disk:                   'Disk gostitelja',
            cert_expiring:               'Certifikat pred potekom',
            cert_expired:                'Potekel certifikat',
            instance_offline:            'Instanca ni dosegljiva',
            stale_applied_version:       'Zastarela uveljavljena različica',
            tag_mismatch:                'Neujemanje oznake slike',
            outdated_agent:              'Zastarel agent',
            reload_failure:              'Ponovno nalaganje ni uspelo',
            router_service_errors:       'Napake router / service',
            clock_drift:                 'Odstopanje ure',
            config_pending_files:        'Manjkajoče datoteke certifikatov',
            static_config_drift:         'Odstopanje static configa',
            agent_outbox_overflow:       'Prepolna izhodna vrsta agenta',
            flatten_invariant_violation: 'Kršitev invariante pri sploščanju',
        },

        // Šestnajst sporočil. Trajanja, količine bajtov, odstotki in števila dni pridejo kot gola
        // števila in jih pred vstavljanjem oblikuje `libs/issue.ts` — `{threshold_seconds}` je do
        // tega stavka že „3 h 20 min“.
        //
        // **Nobeno sporočilo ne vstavlja pretečenega časa, ki bi ga izračunal strežnik**, in ga tudi
        // ne more: strežnik pošlje *izhodiščni trenutek* (`{last_seen_at}`, `{delivered_at}`,
        // `{mismatched_at}`, `{outdated_at}`, `{over_threshold_at}`), kajti vrednost, ki bi rasla
        // vsako minuto, bi ob vsakem poizvedovanju na novo zapisala odgovor in `/dashboard` bi
        // izgubil svoj 304 (pogodba je opisana v Logic/IssueRules.go). Koliko časa je od tega
        // trenutka minilo, pove `{open_for}`, ki ga `libs/issue.ts` izračuna tu, iz polja `since`.
        host_cpu:              'Poraba CPU je {cpu_percent}, nad pragom {threshold_percent} od {over_threshold_at} ({open_for}).',
        host_memory:           'Poraba pomnilnika je {used_percent}, nad pragom {threshold_percent} — na voljo {memory_available_bytes} od {memory_total_bytes}.',
        host_disk:             'Datotečni sistem {path} je zaseden {used_percent}, nad pragom {threshold_percent} — prostih {available_bytes} od {total_bytes}.',
        cert_expiring:         'Certifikat za {domains} poteče čez {days_left} ({not_after}); prag je {threshold_days}.',
        cert_expired:          'Certifikat za {domains} je potekel {not_after}. Vsak brskalnik na tem imenu zdaj dobi stran z napako.',
        instance_offline:      'Brez sinhronizacije od {last_seen_at} ({open_for}), čez prag {threshold_seconds}. Traefik še naprej streže konfiguracijo iz predpomnilnika.',
        stale_applied_version: 'Različica {delivered_version} je bila dostavljena {delivered_at} ({open_for}), lokacija pa še vedno streže {applied_version} (prag {threshold_seconds}).',
        tag_mismatch:          'Traefik teče v različici {running_version}, dodeljena oznaka slike pa je {desired_tag} — od {mismatched_at} ({open_for}), čez prag {threshold_seconds}.',
        outdated_agent:        'Agent {agent_version} se ne ujema s pričakovano različico {expected_version} — od {outdated_at} ({open_for}), čez prag {threshold_seconds}.',
        reload_failure:        'Traefik je zavrnil različico {delivered_version}; lokacija še vedno streže {applied_version}.',
        router_service_errors: 'Traefik poroča o objektih z napako — routers: {router_error_count}, services: {service_error_count}, middlewares: {middleware_error_count} ({objects}).',
        clock_drift:           'Ura lokacije odstopa od ure panela za {drift_seconds}, čez prag {threshold_seconds}. Vsi časi, ki jih ta gostitelj poroča, so za toliko zamaknjeni.',
        config_pending_files:  'Lokacija zadržuje objavljen snapshot — datoteke certifikatov, ki jih zahteva, še niso prispele na disk (manjka: {pending_count}; {pending_files}).',
        static_config_drift:   'Datoteka traefik.yml na gostitelju ni tista, ki jo je panel nazadnje poslal — na disku {on_disk_sha256}, izrisano {rendered_sha256}. Uveljavljanje static configa je zavrnjeno, dokler tega ne razrešite.',
        agent_outbox_overflow: 'Lokacija je med nedosegljivostjo panela zavrgla telemetrijo (zavrženih paketov: {dropped_count}; zadnja sinhronizacija {last_seen_at}). V podatkih te instance je vrzel.',
        flatten_invariant_violation: 'Objava je bila prekinjena: dve skupini zahtevata isti ključ definicije. Instanca še vedno streže zadnji veljavni snapshot in tega ne odpravi noben popravek operaterja.',
    },
    client: {
        clients:    'Stranke',
        client:     'Stranka',
        add:        'Dodaj stranko',
        edit:       'Uredi stranko',
        delete:     'Izbriši stranko',
        name:       'Naziv',
        instances:  'Instance te stranke',
        acme_email: 'ACME e-pošta',
        // D37 — naslov se ob nastanku prepiše na instanco; je privzeta vrednost, ne povezava.
        acme_email_hint:        'Uporablja se kot kontaktni naslov za Let\'s Encrypt. Nove instance te stranke izhajajo iz njega.',
        acme_email_edit_notice: 'Sprememba tega naslova ne spremeni obstoječih instanc. Spremeni le privzeto vrednost, iz katere izhaja naslednja instanca te stranke.',
        delete_confirm:         'Izbrišem stranko „{name}“? To je mogoče le, dokler nima instanc.',
        delete_blocked:         'Stranka „{name}“ ima še instance. Najprej izbrišite te.',
    },
    instance: {
        instances:     'Instance',
        instance:      'Instanca',
        add:           'Dodaj instanco',
        delete:        'Izbriši instanco',
        name:          'Naziv',
        client:        'Stranka',
        select_client: 'Izberite stranko',
        image_tag:     'Različica Traefika',
        acme_email:    'ACME e-pošta',

        name_hint:    'Črke, števke, pika, vezaj in podčrtaj; do 64 znakov. Uporabi se v namestitveni skripti in v compose datoteki na lokaciji.',
        name_invalid: 'Uporabite samo črke, števke, „.“, „-“ in „_“, do 64 znakov.',

        image_tag_hint:          'Pripeta različica, na primer {example}. Premikajočih se oznak, kot je „latest“, ni mogoče preveriti glede na podprti razpon.',
        image_tag_settings_hint: 'Pripeta različica, na primer {example}. Sprememba na lokaciji ponovno ustvari vsebnik; konfiguracijska datoteka se ne prepiše.',
        image_tag_invalid:       'Vnesite pripeto različico, na primer {example}.',

        acme_email_create_hint:    'Predizpolnjeno iz izbrane stranke. Spremenite ga, če ta instanca uporablja drug kontaktni naslov.',
        // §7.10 pravilo 1 / §6.1 — edino polje na tem obrazcu, ki nosi static config.
        acme_email_static_notice:  'Shranjevanje tega polja pošlje novo static konfiguracijo na lokacijo.',
        static_config_queued:      'Sprememba static konfiguracije je uvrščena v vrsto za dostavo na lokacijo.',

        // Sprememba oznake slike je edino urejanje, ki ne spremeni nobene datoteke, ampak zamenja
        // vsebnik (§2.2, §8.4). Potrdi se pred pošiljanjem, ker operater ponovno zaganja tuj proxy.
        image_tag_confirm_title:    'Ponovno ustvari vsebnik',
        image_tag_confirm:          'Želite različico Traefika spremeniti z {from} na {to}? Vsebnik na lokaciji bo zamenjan z novim, ki teče na novi sliki in obdrži svoje ime, labele in omrežja. Med zagonom je usmerjanje prekinjeno, če novi vsebnik ne postane zdrav, pa agent samodejno povrne prejšnjega.',
        recreate_queued:            'Vsebnik bo ponovno ustvarjen na {tag}.',
        static_and_recreate_queued: 'Za lokacijo sta uvrščeni sprememba static konfiguracije in ponovno ustvarjanje vsebnika.',
        view_static_config:         'Odpri static config',

        update_channel: 'Kanal posodobitev',
        // D22 — kanal je nadzor obsega škode, zato opis pove, kaj izbira Canary dejansko pomeni,
        // in ne razlaga besede.
        update_channel_hint: 'Lokacije na kanalu Canary dobijo novo izdajo agenta prve, tako da se slaba izdaja pokaže na peščici lokacij namesto na vseh. Vse ostale ostanejo na Stabilnem.',
        channel: {
            stable: 'Stabilni',
            canary: 'Canary',
        },

        // Vzporednost različic iz §13.2, kot se bere različica agenta, ki jo javi lokacija (W7.7).
        // Primerjamo s *pričakovano* različico — pripenjanje ob povrnitvi jo odmakne od panelove —
        // zato opis v namigu poimenuje prav njo in ne „panel“.
        agent: {
            current:  'Posodobljen',
            outdated: 'Zastarel',
            ahead:    'Novejši od pričakovanega',
            unknown:  'Še ni javil',
            expected: 'Pričakovana različica agenta: {version}',
        },

        // §6.2 `self_update.enabled` je konjunkcija dveh stikal: tega na instanci in tistega na
        // namestitvi panela (`AGENT_SELF_UPDATE_ENABLED`, §13.1). Izrazoslovje ju loči, ker sta
        // „ustavljeno“ in „ustavljeno za celotno floto“ dva različna primera.
        self_update: {
            label:        'Samodejna posodobitev',
            field:        'Samodejna posodobitev za to instanco',
            hint:         'Ko je vklopljena, agent na tej lokaciji sam zamenja sebe z različico, ki jo pričakuje ta panel — sliko prenese, jo pred uporabo preizkusi in samodejno povrne staro, če se nova ne zažene. Izklopite jo, da to eno lokacijo zadržite; strežba teče v obeh primerih naprej.',
            on:           'Samodejna posodobitev vklopljena',
            paused:       'Samodejna posodobitev izklopljena',
            paused_fleet: 'Ustavljena za celotno floto',
        },

        update: {
            column: 'Posodobitve',

            outdated_title: 'Zastarel agent',
            outdated_hint:  'Ta lokacija javlja agenta {reported}; pričakovana različica je {expected}.',

            ahead_title: 'Agent je pred floto',
            ahead_hint:  'Ta lokacija javlja agenta {reported}, flota pa je pripeta na {expected}. Agent se sam vrne na pripeto različico.',

            paused_title: 'Samodejna posodobitev je ustavljena',

            converging_hint:      'Samodejna posodobitev je vklopljena: agent se zamenja v 30 minutah po izdaji, časovno razpršeno po floti, da slabe izdaje ne prevzamejo vse lokacije hkrati.',
            paused_instance_hint: 'Samodejna posodobitev je za to instanco izklopljena, zato ostane na trenutni različici, dokler je kdo pod Nastavitvami ne vklopi nazaj.',
            paused_fleet_hint:    'Samodejna posodobitev je ustavljena za celotno floto. Nastavljena je tam, kjer je nameščen panel (AGENT_SELF_UPDATE_ENABLED), in je od tu ni mogoče spremeniti.',
            paused_both_hint:     'Samodejna posodobitev je izklopljena za to instanco in ustavljena za celotno floto. Vklop te instance ne spremeni ničesar, dokler ni znova vklopljeno stikalo za celotno floto.',

            // §8.5 — odgovor na vprašanje „ali je agenta ponovno zagnal panel?“ na zaslonu, kjer
            // se to vprašanje postavi. Ni ga: samodejne posodobitve nihče ne uvrsti v vrsto.
            queue_note: 'Samodejno posodobitev sproži agent sam in se nikoli ne pojavi v tej vrsti.',

            fleet_paused_title: 'Samodejna posodobitev je ustavljena za celotno floto',
            fleet_paused_hint:  'Dokler je to izklopljeno, se noben agent ne posodobi sam, ne glede na nastavitev posamezne instance. Nastavljeno je tam, kjer je nameščen panel (AGENT_SELF_UPDATE_ENABLED), in iz panela tega ni mogoče spremeniti.',
        },

        enrolment: {
            label:    'Priklop',
            pending:  'Še ni nameščena',
            enrolled: 'Priklopljena',
        },

        // Prisotnost (§4.4) — tretja os, ločena od priklopa (zgodovina) in od stanja (zdravje).
        // „Se še ni javila“ ni „Nedosegljiva“: na tej lokaciji še ni nič nameščeno, in če jo
        // označimo za nedosegljivo, pošljemo operaterja iskat napako na poti, ki še ne obstaja.
        presence: {
            label:      'Agent',
            online:     'Dosegljiv',
            offline:    'Nedosegljiv',
            never_seen: 'Se še ni javil',
        },
        last_seen: 'zadnje javljanje {at}',

        // Barve stanj iz §9.5. Od M5 naprej jih polni GET /instances/:id/state.
        status: {
            healthy:       'Zdrava',
            degraded:      'Okrnjena',
            config_stale:  'Zastarela konfiguracija',
            reload_failed: 'Ponovno nalaganje ni uspelo',
            offline:       'Nedosegljiva',
            pending:       'V čakanju',
        },

        tabs: {
            overview:      'Pregled',
            runtime:       'Runtime',
            groups:        'Groups',
            snapshots:     'Snapshots',
            commands:      'Ukazi',
            certificates:  'Certifikati',
            static_config: 'Static config',
            access:        'Dostop',
            settings:      'Nastavitve',
            install:       'Namestitev',
        },
        tab_pending: 'Ta zaslon pride v {milestone}.',

        read_only:      'Samo za branje',
        read_only_hint: 'Do te instance imate bralni dostop. Spreminjanje vam ni na voljo.',

        not_available:      'Instanca ni na voljo',
        not_available_hint: 'Ne obstaja ali pa do nje nimate dostopa.',

        snapshot_version:      'Objavljen snapshot',
        static_configuration:  'Static konfiguracija',
        entrypoints:           'Entrypoints',
        resolvers:             'Resolvers',
        redirect:              'Preusmeritev HTTP → HTTPS',
        redirect_permanent:    'Vklopljena, trajna (301).',
        redirect_temporary:    'Vklopljena, začasna (302).',
        redirect_disabled:     'Izklopljena.',

        danger_zone: 'Nevarno območje',
        delete_hint: 'Odstrani instanco iz panela in prekliče poverilnice njenega agenta.',
        // D11 — posledico je treba prebrati pred odločitvijo, ne odkriti po njej.
        delete_confirm: 'Izbrišem instanco „{name}“? Traefikov vsebnik na lokaciji še naprej teče in streže trenutno konfiguracijo, a ne bo več prejemal sprememb in ga ni mogoče znova povezati.',
    },
    // Zavihek za namestitev (§9.1, W3.9). Dve temi: poverilnica, ki jo operater prenaša na roko,
    // in poročilo v štirih korakih o tem, kaj je gostitelj stranke z njo naredil (§6 korak 2, §13.3).
    install: {
        command_title: 'Namestitveni ukaz',
        intro:         'Ukaz zaženite na gostitelju stranke kot root. Če Dockerja ni, ga namesti, ustvari /opt/traefik, zažene Traefik skupaj z agentom in priklopi to instanco.',

        none_yet_title: 'Namestitvenega ukaza še ni',
        none_yet:       'Ustvarite ga, ko ste pripravljeni na namestitev. Uporabiti ga je mogoče enkrat in velja omejen čas.',
        generate:       'Ustvari namestitveni ukaz',
        regenerate:     'Ustvari novega',
        // §6.1 — novi ukaz razveljavi vse neuporabljene prejšnje; prav to naredi ponovno
        // ustvarjanje pravi ukrep ob razkriti povezavi in ne druge žive poverilnice poleg nje.
        regenerate_confirm: 'Ustvarim nov namestitveni ukaz? Prejšnja povezava takoj preneha delovati, tudi če je že prilepljena v terminal.',

        copy:             'Kopiraj',
        copied:           'Namestitveni ukaz je kopiran',
        copy_unsupported: 'Brskalnik kopiranja ni dovolil. Označite ukaz in ga kopirajte ročno.',
        mint_failed:      'Namestitvenega ukaza ni bilo mogoče ustvariti',

        // R25 — obseg škode, povedan tako, da operater lahko ukrepa.
        secret_title: 'Ukaz obravnavajte kot geslo',
        secret_hint:  'Povezava vsebuje enkratni žeton. Kdor ga ima, lahko za to instanco priklopi agenta in prejme njeno konfiguracijo in certifikate. Prikaže se enkrat in panel njegove kopije ne hrani — če zapustite to stran, boste morali ustvariti novega.',
        run_as_root:  'Skripta potrebuje root na Linuxu (x86_64 ali aarch64). Če so vrata 80 ali 443 že zasedena, se ustavi in ničesar ne spremeni.',

        expires_in:   'Velja še {value}',
        expired:      'Poteklo',
        expired_hint: 'Te povezave ni več mogoče uporabiti. Za namestitev ustvarite novo.',
        remaining_hm: '{hours} h {minutes} min',
        remaining_ms: '{minutes} min {seconds} s',
        remaining_s:  '{seconds} s',

        // §9.6 — polovica strani, ki nosi skrivnost, zahteva pravico pisanja; končna točka jo tudi uveljavi.
        write_required: 'Za ustvarjanje namestitvenega ukaza potrebujete pravico pisanja na tej instanci.',

        progress_title: 'Potek namestitve',
        poll_hint:      'Preverjamo vsakih nekaj sekund. Agent se javi vsakih 10 sekund, lokacija, ki molči {seconds} sekund, pa velja za nedosegljivo.',
        online_title:   'Lokacija je dosegljiva',
        online_hint:    'Agent se javlja, Traefik pa dobiva svojo konfiguracijo. Spremembe iz panela od zdaj naprej pridejo do te lokacije same.',

        steps: {
            created: {
                title: 'Instanca ustvarjena',
                done:  'Ustvarjena {at}',
            },
            script_fetched: {
                title: 'Namestitvena skripta prenesena',
                // §13.3 — izvorni naslov se zabeleži, da je nepričakovan prenos viden.
                done:         'Prenesena {at} z naslova {ip}',
                done_no_ip:   'Prenesena {at}',
                done_unknown: 'Gostitelj je zagnal namestitveno skripto.',
                pending:      'Čakamo, da gostitelj prenese skripto.',
            },
            enrolled: {
                title:        'Agent priklopljen',
                done:         'Priklopljen {at}',
                done_unknown: 'Agent je priklopljen.',
                pending:      'Čakamo, da agent zamenja svoj enkratni žeton.',
            },
            online: {
                title:   'Javlja se',
                done:    'Zadnje javljanje {at}',
                stale:   'Nič od {at}.',
                pending: 'Čakamo na prvo javljanje.',
            },
        },
    },
    // Zasloni z živim stanjem (zavihka Pregled in Runtime iz §9.1, W5.6). Skozi ves ta blok tečeta
    // dve pravili: Traefikovi izrazi ostanejo v angleščini v obeh jezikih (§9.5), in nič tu ne
    // preubeseduje izpisa tretjih oseb — Traefikove napake ob nalaganju in Dockerjeve besede se
    // izpišejo dobesedno v `<pre>`, zato zanje ni ključa.
    runtime: {
        poll_failed:  'Osveževanje ni uspelo — prikazano je zadnje javljanje',
        collected_at: 'zajeto {at}',

        // Tri dejstva iz ADR-0007. Tri oznake, ker so to tri vprašanja s tremi različnimi odgovori
        // in tremi različnimi lastniki.
        delivered: 'Dostavljeno',
        applied:   'Uveljavljeno',
        health:    'Zdravje',

        health_ok:       'Brez napak',
        health_degraded: 'Ni povsem zdravo',
        health_errors:   '{count} z napako',
        health_unknown:  'Se še ni javilo',
        unreachable:     'Traefik ni dosegljiv',
        open_runtime:    'Pokaži',

        unreachable_title: 'Agent ne doseže Traefika',
        unreachable_hint:  'Agent se javlja, Traefikov API poleg njega pa ne odgovarja. Spodnji seznami routerjev, servicev in middlewarov so prazni zato, ker ni bilo mogoče ničesar prebrati — ne zato, ker jih Traefik ne bi imel.',

        clock_drift_title: 'Ura te lokacije ni usklajena',
        clock_drift_hint:  'Ura agenta se od panelove razlikuje za približno {seconds} s. Za vse časovne oznake na tej strani se uporablja panelova ura, zato tu ni nič narobe — bosta pa obnavljanje certifikatov in povezovanje dnevnikov na lokaciji.',

        dropped_telemetry: 'Panel je bil nedosegljiv dovolj dolgo, da je agent zavrgel {count} telemetrijskih poročil. V zgodovini je vrzel; nič kritičnega ni bilo izgubljeno.',

        entrypoints_live:     'Traefik posluša na',
        entrypoint_redirects: 'Preusmerja na {to}',

        // Po en stavek za vsako stopnjo lestvice iz §9.5, ki pove, iz katerega dejstva je izbrana.
        hint: {
            pending:       'Za to instanco se še ni javilo nič. Zaženite namestitveni ukaz na gostitelju stranke.',
            offline:       'Brez javljanja že več kot {seconds} sekund. Traefik na lokaciji še naprej streže shranjeno konfiguracijo.',
            reload_failed: 'Traefik ni potrdil ponovnega nalaganja za v{version}. Še vedno streže prejšnjo konfiguracijo.',
            stalled:       'Traefik v{version} sploh ni prevzel. Ali ne teče ali pa je usmerjen na drug vir konfiguracije.',
            config_stale:  'Objavljena je v{delivered}; lokacija še vedno teče na v{applied}.',
            unreachable:   'Agent se javlja, Traefikov API poleg njega pa ne odgovarja.',
            pending_files: 'Čakamo na {count} datotek(o) certifikatov, ki jih zahteva objavljena konfiguracija.',
            degraded:      'Uveljavljeno, pri čemer je {count} routerjev, servicev ali middlewarov v napaki.',
            healthy:       'Streže v{version} brez javljenih napak.',
        },

        // Razsodbe applyWatch iz §8.6 (ADR-0004, odločitev 6). „Ponovno nalaganje ni bilo potrebno“
        // je uspeh: dosegljivo je le ob pozitivnem dokazu, nikoli kot privzeti izhod.
        apply: {
            applied:     'Ponovno naloženo',
            noop:        'Ponovno nalaganje ni bilo potrebno',
            failed:      'Zavrnjeno',
            stalled:     'Ni bilo prevzeto',
            unconfirmed: 'Nepotrjeno',
            unknown:     'Še ni razsojeno',

            reason_unknown: 'Agent ni sporočil, katera veja je odločila.',
            no_detail:      'Traefik ni sporočil ničesar več.',

            reason: {
                byte_identical:  'Postreženi dokument je bil bajt za bajt enak že uveljavljenemu, zato ni bilo ničesar za ponovno naložiti.',
                reload_observed: 'Traefikova števca ponovnih nalaganj sta se premaknila čez izhodišče, izmerjeno pred prevzemom te različice.',
                equivalent:      'Traefik je prevzel drugačen dokument in ga ni ponovno naložil, v dnevniku pa ni napake — imel ju je za enakovredna.',
                rejected:        'Traefik je za ta dokument zapisal napako providerja in obdržal prejšnjega.',
                unconfirmed:     'Ponovnega nalaganja ni bilo mogoče opaziti, dnevnika Traefikovega vsebnika pa ni bilo mogoče prebrati, zato izid ni znan.',
                not_fetched:     'Traefik te različice v opazovalnem oknu sploh ni prevzel.',
            },

            title: {
                apply_failed:      'Traefik je to konfiguracijo zavrnil',
                apply_stalled:     'Traefik ne prevzema svoje konfiguracije',
                apply_unconfirmed: 'Ponovnega nalaganja ni bilo mogoče potrditi',
            },
            hint: {
                apply_failed:      'v{version} je bila objavljena in zavrnjena. Lokacija še naprej streže zadnjo konfiguracijo, ki se je naložila, zato se ni nič pokvarilo — sprememba pa ni v živo. Sledi Traefikova lastna napaka.',
                apply_stalled:     'v{version} je bila objavljena, Traefik pa je ni zahteval. Preverite, ali vsebnik teče in ali njegova static konfiguracija še kaže na agenta.',
                apply_unconfirmed: 'Za v{version} ponovnega nalaganja ni bilo mogoče opaziti, dnevnika Traefikovega vsebnika pa ni bilo mogoče prebrati. Panel to sporoči kot nepotrjeno, namesto da bi ugibal.',
            },
        },

        // Traefikove lastne besede za stanje objekta; zapisane tako, kot jih zapiše Traefik.
        status: {
            enabled:  'Enabled',
            warning:  'Warning',
            disabled: 'Disabled',
            error:    'Napaka',
            unknown:  'Neznano',
        },

        host: {
            title:  'Gostitelj',
            cpu:    'CPU',
            memory: 'Pomnilnik',
            swap:   'Swap',
            load:   'Povprečna obremenitev',
            cores:  'Jedra',
            window: 'Okno vzorčenja',
            window_value: '{seconds} s',
            of_total: 'zasedeno {used} od {total}',

            // §8.6 — označeno delno poročilo je boljše od neuspelega, a le, če to tudi pove.
            partial_title: 'Te številke opisujejo vsebnik, ne gostitelja',
            partial_hint:  'Agent je nameščen brez priklopa gostiteljskega datotečnega sistema, zato lahko izmeri samo sebe. Na vse drugo na tej strani to ne vpliva.',
            problems:      'Česa ni bilo mogoče prebrati',

            none:      'Meritev gostitelja še ni',
            none_hint: 'Agent meritve gostitelja javlja vsakih 60 sekund, ko teče.',
        },

        containers: {
            title:  'Vsebniki',
            name:   'Ime',
            state:  'Stanje',
            uptime: 'Teče',
            image:  'Slika',
            id:     'ID',

            managed:      'Upravljan',
            managed_hint: 'Ta vsebnik je last tega panela, ki ga lahko znova zažene ali ustvari na novo.',

            // §8.6 / D20 — kratek seznam ima dva zelo različna vzroka, na zaslonu pa sta enaka.
            filtered:  'Ta lokacija javlja samo vsebnike, ki jih ima v lasti ta panel. Drugih delovnih obremenitev stranke namenoma ne pošilja.',
            truncated: 'Prikazanih {shown} od {total} vsebnikov — agent se ustavi pri svoji zgornji meji, da en podivjan gostitelj ne more poročila napihniti v megabajt.',

            none:      'Javljenih vsebnikov ni',
            none_hint: 'Agent našteje vse vsebnike na gostitelju, takoj ko teče.',
        },

        cert: {
            title:      'Certifikati',
            expired:    'Potekel',
            days_left:  'še {days} d',
            not_after:  'Poteče {at}',
            total:      '{count} v strežbi',
            expiring:   '{count} kmalu poteče',
            critical:   '{count} pravkar poteka',
            partial:    'Enega od virov certifikatov ni bilo mogoče prebrati — acme.json manjka, ni berljiv ali se prav zdaj prepisuje med obnavljanjem. Prikazano je tisto, kar je bilo mogoče prebrati.',
            none:       'Javljenih certifikatov ni',
            none_hint:  'Traefikov vgrajeni samopodpisani privzeti certifikat je namenoma odfiltriran, zato instanca, ki streže samo njega, tu ne pokaže ničesar.',
            tab_pending: 'Celoten popis, ročna nalaganja in stanje dostave so na zavihku Certifikati.',
        },

        versions: {
            title:   'Različice',
            agent:   'Agent',
            traefik: 'Traefik',
            panel:   'Panel',
            started_at: 'teče od {at}',
            tag_mismatch:      'Ni nastavljena različica',
            tag_mismatch_hint: 'Ta instanca je nastavljena na {expected}. Uskladi ju ponovni zagon ali vnovično ustvarjanje vsebnika.',
        },

        // Politika izrazoslovja iz §9.5: trije namespaci so Traefikovi izrazi in ostanejo v angleščini.
        kinds: {
            routers:     'Routers',
            services:    'Services',
            middlewares: 'Middlewares',
        },

        table: {
            name:        'Ime',
            status:      'Stanje',
            rule:        'Rule',
            service:     'Service',
            entrypoints: 'Entrypoints',
            type:        'Tip',
            servers:     'Strežniki',
            used_by:     'Uporablja',
            owner:       'Group',
            provider:    'Provider',

            search_placeholder: 'Iskanje po imenu, ruleu, serviceu ali groupu',
            count:      '{shown} od {total}',
            errors:     '{count} z napako',
            error_title: 'Traefik o {name}',

            // W5.5 — prazen lastnik je pravi odgovor, ne manjkajoč.
            no_owner:      'Ni iz groupa',
            no_owner_hint: 'Tega imena na tej instanci ne zahteva noben group. Prihaja od drugega Traefikovega providerja — oznake Dockerja na gostitelju ali datoteke, ki je panel ne upravlja.',

            no_match:      'Iskanju ne ustreza nič',
            no_match_hint: 'Izpraznite iskalno polje, da vidite vse, kar javlja Traefik.',
            none: {
                routers:     'Traefik ne javlja nobenega routerja',
                services:    'Traefik ne javlja nobenega servica',
                middlewares: 'Traefik ne javlja nobenega middlewara',
            },
            none_hint: 'Objekti se pokažejo tu takoj, ko Traefik naloži konfiguracijo, ki jih definira.',

            truncated_title: 'Ta seznam ni celoten',
            truncated_hint:  'Agent se je pri paginaciji ustavil pri svoji zgornji meji. Prikazan je omejen vzorec, merodajne pa so števke, ki jih javlja Traefik.',
        },
    },
    // Vrsta ukazov (§4.3, §8.4, W6.9). Trije *tipi* ukazov so poimenovani v operaterjevem jeziku
    // in ne v jeziku protokola — `restart_traefik` je vrednost, „Ponovno zaženi Traefik“ je
    // poved — ime „Traefik“ pa je ime izdelka in ostane nespremenjeno v obeh jezikih.
    command: {
        commands:  'Ukazi',
        command:   'Ukaz',
        queue:     'Zaženi ukaz',
        in_flight: 'V teku',
        view:      'Poglej ukaz',
        open:      'Odpri',
        cancel:    'Prekliči ukaz',

        sequence:     '#',
        type_label:   'Ukaz',
        status_label: 'Stanje',
        queued_at:    'V vrsti od',
        finished_at:  'Zaključeno',
        outcome:      'Izid',
        attempts:     'Izvedeno {count}×',
        duration:     'na lokaciji trajalo {seconds} s',
        deadline_at:  'Rok {at}',
        payload:      'Kaj ukaz nosi',
        raw_output:   'Izpis z lokacije',
        note:         'Ni bilo česa storiti',

        // §9.5 — zgolj prikaz. Shranjeno stanje ostane `queued`; spremeni se poved, ki jo bere
        // operater: „v vrsti“ pri zdravi lokaciji pomeni „čez nekaj sekund“, pri tihi pa
        // „pojdite pogledat gostitelja“.
        offline_title:      'Ta lokacija se ne javlja',
        offline_hint_seen:  'Ukazi v vrsti se prevzamejo ob naslednji sinhronizaciji lokacije. Zadnje javljanje: {at}.',
        offline_hint_never: 'Ukazi v vrsti se prevzamejo ob naslednji sinhronizaciji lokacije, ta lokacija pa se še ni nikoli javila.',

        rolled_back_short: 'Povrnjeno',
        rolled_back_title: 'Prejšnji vsebnik je bil povrnjen',
        rolled_back_hint:  'Ponovno ustvarjanje ni uspelo in agent je lokacijo vrnil na vsebnik, ki je tekel prej. Lokacija je ves čas stregla.',

        not_found:      'Ta ukaz ni na voljo',
        not_found_hint: 'Na tej instanci ne obstaja ali pa je bil odstranjen iz vrste.',

        queued_toast:   'Ukaz je uvrščen v vrsto za dostavo na lokacijo.',
        queue_failed:   'Ukaza ni bilo mogoče uvrstiti v vrsto',
        cancel_confirm: 'Želite preklicati ukaz {type}, ki čaka v vrsti? V vrsti ostane kot preklican, skupaj s podatkom, kdo ga je preklical.',
        cancel_failed:  'Ukaza ni bilo mogoče preklicati',

        // Življenjski cikel (§4.3). `delivering` in `delivered` sta namenoma dve besedi za dve
        // dejstvi: panel je ukaz dal v odgovor sinhronizacije, agent pa je njegov id vrnil nazaj.
        status: {
            queued:         'V vrsti',
            delivering:     'Pošiljanje',
            delivered:      'Prevzeto na lokaciji',
            executing:      'Izvajanje',
            applied:        'Uveljavljeno',
            failed:         'Neuspelo',
            superseded:     'Preklicano',
            queued_offline: 'V vrsti — instanca je nedosegljiva',
        },

        type: {
            restart_traefik:     'Ponovno zaženi Traefik',
            recreate_traefik:    'Ponovno ustvari vsebnik',
            apply_static_config: 'Uveljavi static config',
        },
        type_hint: {
            restart_traefik:     'Ponovno zažene vsebnik Traefika. Konfiguracijskih datotek se ne dotakne.',
            recreate_traefik:    'Vsebnik zamenja z novim, ki teče na oznaki slike te instance, pri tem pa obdrži ime, labele in omrežja. Če novi vsebnik ne postane zdrav, samodejno povrne prejšnjega.',
            apply_static_config: 'Na lokacijo zapiše panelova traefik.yml in traefik.env ter nato ponovno zažene ali ustvari Traefik, da začneta veljati. Prejšnji datoteki se prej varnostno kopirata.',
        },
        confirm: {
            restart_traefik:  'Želite na tej lokaciji ponovno zagnati Traefik? Usmerjanje je za nekaj sekund prekinjeno, dokler se vsebnik ne vrne.',
            recreate_traefik: 'Želite na tej lokaciji ponovno ustvariti vsebnik Traefika? Agent prenese sliko, vsebnik zamenja z novim z enakim imenom, labelami in omrežji, ob nezdravem zagonu pa povrne prejšnjega.',
        },

        // Pet časovnih žigov in čigava ura je posamezni žig (§5.1, §8.6).
        ladder: {
            queued:     'Uvrščeno v vrsto v panelu',
            delivering: 'Poslano na lokacijo',
            delivered:  'Prevzeto na lokaciji',
            started:    'Izvajanje se je začelo',
            finished:   'Izvajanje se je končalo',
        },
        clock: {
            panel: 'ura panela',
            site:  'ura lokacije',
        },

        payload_image:                'Slika',
        payload_restart_mode:         'Način zagona',
        payload_restart_mode_hint:    'Namera panela. Agent namesto ponovnega zagona vsebnik ponovno ustvari vsakič, ko se spremeni datoteka z okoljem, saj Docker okolje vsebnika določi ob njegovem nastanku.',
        payload_materials_hash:       'Zgoščena vrednost gradiv',
        payload_materials_hash_hint:  'Datoteke, ki jih mora lokacija že imeti. Ukaz sam ne nosi konfiguracije — bajti so potovali ločeno in se preverijo proti tej zgoščeni vrednosti.',
        payload_force_overwrite:      'Prepiši lokalne spremembe',
        payload_force_overwrite_hint: 'Ta uveljavitev je bila pooblaščena, da prepiše datoteko, ki je bila spremenjena na lokaciji. Agent obstoječo datoteko pred zamenjavo varnostno kopira.',
        payload_none:                 'Nič',
        payload_none_hint:            'Ponovni zagon ne potrebuje parametrov: vse, na kar deluje, agent o svoji lokaciji že ve.',

        restart_mode: {
            restart:  'ponovni zagon',
            recreate: 'ponovno ustvarjanje',
        },

        // Taksonomija napak iz §8.4. Vsaka vrednost pomeni drugo naslednje dejanje — prav zato
        // kode obstajajo namesto ene rdeče značke. Neprepoznana koda se izpiše dobesedno (§8.6).
        error: {
            unsupported_command: 'Agent tega ukaza ne podpira',
            invalid_payload:     'Agent je zavrnil parametre ukaza',
            precondition_failed: 'Lokacija ni bila v stanju, ki ga ta ukaz zahteva',
            static_config_drift: 'Konfiguracijska datoteka na lokaciji je bila spremenjena zunaj panela',
            image_not_allowed:   'Ta slika ni na dovoljenem seznamu agenta',
            image_pull_failed:   'Slike ni bilo mogoče prenesti. Traefik je še naprej tekel na prejšnji.',
            container_not_found: 'Agent ni našel vsebnika Traefika',
            health_gate_failed:  'Vsebnik v predvidenem času ni postal zdrav',
            docker_error:        'Docker je operacijo zavrnil',
            filesystem_error:    'Agent ni mogel pisati na lokaciji',
            timeout:             'Do izteka roka ni prispel noben izid',
            internal_error:      'Agent je odpovedal iz notranjega razloga',
        },
    },
    // Certificate resolverji (§2.2, §7.11, W6.9). „Resolver“, „challenge“ in identifikatorji
    // ponudnikov iz lega so izrazje Traefika oziroma ACME in v obeh jezikih ostanejo v
    // angleščini (§9.5).
    resolver: {
        add:          'Dodaj resolver',
        add_hint:     'Resolverja pozneje ni mogoče preimenovati: ime je ključ certifikatov, izdanih pod njim.',
        name:         'Ime',
        name_hint:    'Črke, števke, vezaj in podčrtaj; do 32 znakov. V static konfiguracijo se izpiše kot certificatesResolvers.<ime>.',
        name_invalid: 'Uporabite samo črke, števke, „-“ in „_“, do 32 znakov.',
        challenge:    'Challenge',
        delete:       'Izbriši resolver',

        section_hint:  'ACME certificate resolverji, ki jih ta instanca deklarira. Dodajanje, odstranitev ali zamenjava poverilnic pošlje na lokacijo novo static konfiguracijo.',
        none:          'Ta instanca ne deklarira nobenega resolverja.',
        default_badge: 'Privzeti',
        not_removable: 'Privzeti resolver je del vsake instance in ga ni mogoče odstraniti.',

        static_notice:             'Dodajanje resolverja pošlje na lokacijo novo static konfiguracijo.',
        credentials_static_notice: 'Zamenjava teh poverilnic pošlje na lokacijo novo static konfiguracijo in ponovno ustvari vsebnik, saj Docker okolje vsebnika določi ob njegovem nastanku.',

        delete_confirm: 'Želite izbrisati resolver „{name}“? Ob naslednji uveljavitvi izgine iz datoteke traefik.yml na lokaciji. Certifikati, izdani pod njim, ostanejo v acme.json na lokaciji, a se nehajo obnavljati.',

        added:                'Resolver „{name}“ je dodan. Za lokacijo je uvrščena sprememba static konfiguracije.',
        deleted:              'Resolver „{name}“ je odstranjen. Za lokacijo je uvrščena sprememba static konfiguracije.',
        credentials_replaced: 'Poverilnice za „{name}“ so zamenjane. Za lokacijo je uvrščena sprememba static konfiguracije.',
        credentials_missing:  'Ta dns01 resolver nima shranjenih poverilnic.',

        replace_credentials:      'Zamenjaj poverilnice',
        replace_credentials_hint: 'Za resolver „{name}“. Shranjene vrednosti se nikoli ne prikažejo — z zamenjavo se zapiše cel nov nabor.',

        challenge_hint: {
            tlsalpn01: 'Odgovori se na vratih 443, ki jih vsaka instanca že objavlja. Nič drugega ni potrebno.',
            http01:    'Odgovori se na vratih 80, ki morajo biti dosegljiva z interneta.',
            dns01:     'Odgovori se z zapisom v DNS. Edini challenge, ki izda nadomestne (wildcard) certifikate, in edini, ki potrebuje poverilnice ponudnika.',
        },
    },
    // Katalog ponudnikov DNS (§7.11, `GET /dns-providers`). Imena ponudnikov, identifikatorje in
    // imena spremenljivk okolja postreže API in se izpišejo dobesedno — operater jih primerja z
    // legovo dokumentacijo.
    dns: {
        provider:        'Ponudnik DNS',
        provider_hint:   'Spodnja polja so ustvarjena glede na izbranega ponudnika, tako da vam imena spremenljivke okolja ni treba nikoli vtipkati.',
        select_provider: 'Izberite ponudnika',
        docs:            'Dokumentacija ponudnika',
        catalog_failed:  'Seznama ponudnikov ni bilo mogoče naložiti. Osvežite stran in poskusite znova.',

        provider_id:             'legov id ponudnika',
        provider_id_hint:        'Id natanko tako, kot ga piše lego, na primer „azuredns“. Panel o njem ne preverja ničesar.',
        provider_id_placeholder: 'id-ponudnika',

        other_title: 'Nepreverjen ponudnik',
        other_hint:  'Niti id niti imena spremenljivk niso preverjeni. Napaka tu ustvari static konfiguracijo, s katero se Traefik zažene, ACME challenge pa se nikoli ne zaključi.',

        variables:      'Spremenljivke okolja',
        add_variable:   'Dodaj spremenljivko',
        variable_name:  'IME_SPREMENLJIVKE',
        variable_value: 'Vrednost',
        no_variables:   'Zaenkrat ni spremenljivk.',

        key_set:             'Vrsta poverilnic',
        key_set_primary:     'Priporočeno',
        key_set_alternative: 'Druga možnost',
        optional_variable:   'Neobvezno',
        replace_whole_set:   'Te poverilnice se zamenjajo v celoti: izpolnite vsa polja, tudi tista, ki jih ne spreminjate.',

        status: {
            recommended: 'Priporočeno',
            unavailable: 'Ni na voljo',
            unvalidated: 'Ni preverjeno',
        },
    },
    // Zavihek Certifikati (§4.5, §4.6, §7.2, §7.9, §9.1, W9.4/W9.7): posredovani certifikati — kar
    // Traefik dejansko servira — in upravljani certifikati — nalaganja tega panela.
    certificate: {
        upload:      'Naloži certifikat',
        upload_hint: 'Ključ po zapiranju tega okna ni več prikazan.',
        replace:      'Zamenjaj certifikat',
        replace_hint: 'Za »{name}«. Zamenjava certifikata spremeni njegovo pot, zaradi česar ga Traefik znova naloži — brez ponovnega zagona, brez izpada.',
        delete:       'Izbriši certifikat',

        name:            'Ime',
        cert_pem:        'Certifikat (PEM)',
        cert_pem_hint:   'List certifikata, po možnosti sledi njegova veriga, natanko kot je bil izdan.',
        cert_pem_format_hint: 'To ni videti kot certifikat PEM — začeti bi se moral z »-----BEGIN CERTIFICATE-----«.',
        key_pem:         'Zasebni ključ',
        key_pem_hint:    'Po shranjevanju nikoli več prikazan (§4.5). Zamenjava zapiše popolnoma nov par.',
        key_pem_format_hint: 'To ni videti kot zasebni ključ PEM — začeti bi se moral z »-----BEGIN«.',

        no_restart_notice: 'Certifikati se dostavijo na lokacijo in jih Traefik prevzame z dejanskim ponovnim nalaganjem konfiguracije — nikoli s ponovnim zagonom, nikoli z izpadom.',

        delete_confirm: 'Izbrišem »{name}« ({domains})? Traefik ga preneha servirati ob naslednjem ponovnem nalaganju.',
        deleted:        '»{name}« izbrisan.',
        saved_published: 'Certifikat shranjen. Objavljen kot v{version}.',
        saved_unchanged: 'Certifikat shranjen. Enak je že objavljenemu.',

        source: {
            acme:   'ACME',
            manual: 'Ročno',
        },

        delivery: {
            staged:    'V pripravi',
            delivered: 'Dostavljen',
            serving:   'V uporabi',
        },

        served: {
            title: 'Posredovani certifikati',
        },

        managed: {
            title:         'Upravljani certifikati',
            section_hint:  'Certifikati, dodani centralno v panelu in poslani na lokacijo (§4.5). Zasebni ključ po shranjevanju ni nikoli več prikazan.',
            none:          'Ni še upravljanih certifikatov.',
            none_hint:     'Naložite certifikat, da ga bo ta instanca servirala.',
            none_read_only: 'Ni upravljanih certifikatov, dostop imate le za branje.',
        },
    },
    // Polje samo za pisanje iz §9.3. Shranjene vrednosti nikoli ne prikaže in je nikoli ne
    // zahteva: panel nima ničesar, kar bi lahko pokazal (§5.1).
    write_only: {
        set_at:       'nastavljeno {at}',
        set_by:       'nastavil {by}, {at}',
        replace_hint: 'Shranjena vrednost bo zamenjana s tem, kar vnesete tukaj.',
    },
    // Zavihek static konfiguracije (§6.1, §7.10, W6.8/W6.9/W6.11). "static config", imeni obeh
    // datotek in "entrypoint" so Traefikovo besedišče in ostanejo v angleščini v obeh jezikih
    // (§9.5): prav po njih operater išče po Traefikovi dokumentaciji in po gostitelju.
    static_config: {
        hint:         'Traefik ob zagonu prebere ti dve datoteki. Panel ju izriše iz nastavitev te instance — urejevalnika static konfiguracije v panelu ni: spremenite naslov ACME, resolverje ali različico Traefika in naslednji apply zapiše rezultat na lokacijo.',
        refresh:      'Osveži',
        source_label: 'Vir: {source}',
        rendered_at:  'Izrisano {at}',
        // Ključa sta poimenovana po vrednostih na povezavi (`StaticConfigSource`), besedilo pa je
        // za operaterja: `agent` je v v1 napovedan in neuporabljen, a ko bo lokacija pošiljala
        // svoje bajte, je oznaka že tu.
        source: {
            panel: 'Panel',
            agent: 'Lokacija',
        },

        // §9.6 / R12 — opozorilo pove le tisto, kar sporoča zastavica strežnika. SPA ne skriva
        // nobene vrednosti, saj bi skrivanje v brskalniku pomenilo, da mu je bilo besedilo prej
        // sploh treba poslati.
        redacted_title: 'Vrednosti poverilnic niso prikazane',
        redacted:       'Ta instanca hrani poverilnice DNS. Strežnik njihove vrednosti odstrani, še preden nastane ta stran, zato datoteka na lokaciji vsebuje več, kot kaže ta zaslon.',

        // Tri stanja, ne dve: "ujemanje" trdimo le, kadar oba prstna odtisa obstajata in sta enaka.
        in_sync:      'Ujema se z lokacijo',
        not_compared: 'Še ni primerjano',

        // §7.10 pravilo 3 — panel ima prstni odtis gostiteljeve datoteke, njenih bajtov pa nikoli,
        // zato druge strani za primerjavo ni. Bolje je to povedati kot pokazati prazno razliko, ki
        // bi se brala kot "datoteki sta enaki".
        diff_unavailable: {
            on_disk_body_not_reported: 'Lokacija še ni sporočila vsebine svoje datoteke — starejši agent ali lokacija, ki še ni uveljavila konfiguracije. Prstna odtisa zgoraj sta tisto, kar lahko panel primerja.',
            on_disk_body_matches:      'traefik.yml na lokaciji je tista, ki jo je poslal panel, zato je razlika v traefik.env — datoteki z DNS poverilnicami, ki nikoli ne zapusti gostitelja — ali v vrednosti, ki je skrita na obeh straneh.',
            diff_too_large:            'Datoteka na lokaciji je prevelika za primerjavo po vrsticah. Prstna odtisa zgoraj še vedno kažeta, da se razlikuje.',
            unknown:                   'Panel za to razliko ne more prikazati primerjave prej/potem.',
        },

        drift: {
            title:       'Datoteka na lokaciji je bila spremenjena',
            badge:       'Spremenjeno na lokaciji',
            alert_title: 'Spremembe static konfiguracije so zaustavljene',
            alert:       'Nekdo je na gostitelju uredil traefik.yml ali traefik.env. Dokler to ni razrešeno, je vsaka sprememba, ki bi ju prepisala, zavrnjena in ne uveljavljena — panel ročnega popravka ne uniči tiho. Spremembo vnesite v nastavitve te instance ali opustite kopijo z gostitelja.',

            panel_digest: 'Nazadnje poslano iz panela',
            host_digest:  'Sporočeno z lokacije',
            digest_none:  'Nič sporočenega',
            host:         'Na lokaciji',
            panel:        'Iz panela',

            diff_unavailable_title: 'Primerjave prej/potem ni mogoče prikazati',
            discard_action:         'Opusti spremembe gostitelja',
            read_only:              'Za razrešitev potrebujete pravico pisanja na tej instanci.',
        },

        discard: {
            title:    'Opusti spremembe gostitelja',
            subtitle: 'Datoteki na lokaciji “{name}” se nadomestita s panelovima.',

            consequence_title: 'Tega iz panela ni mogoče razveljaviti',
            consequence:       'Kar je bilo spremenjeno na gostitelju, preneha veljati v trenutku, ko se novi datoteki uveljavita. Panel teh datotek ni nikoli prebral in jih ne more obnoviti.',

            point_backup:      'Agent obstoječi datoteki pred zamenjavo prekopira v data/agent/backup/<časovni-žig>/ na lokaciji.',
            point_entrypoints: 'Entrypointi so določeni ob namestitvi, zato ročno dodan entrypoint izgine. Spremembo, ki jo je vredno obdržati, je treba vnesti v nastavitve instance.',
            point_restart:     'Traefik se ponovno zažene — ali ustvari na novo, če se je spremenila datoteka z okoljem — da nova konfiguracija začne veljati. Med tem je usmerjanje prekinjeno.',

            type_to_confirm: 'Za potrditev vpišite “{name}”',
            confirm:         'Opusti in prepiši',
            queued:          'Prepis je uvrščen v vrsto za lokacijo. Datoteki gostitelja se pred zamenjavo varnostno kopirata.',
            failed:          'Prepisa ni bilo mogoče uvrstiti v vrsto',
        },
    },
    // Zasloni za groupe (§9.4, W4.5). "Group" je — enako kot router/service/middleware —
    // Traefikov domenski izraz in ostane v angleščini v obeh jezikih (§9.5); enako velja za imena
    // šestih namespaceov definicij, ki se izpišejo dobesedno tako, kot jih pošlje API.
    group: {
        groups: 'Groups',
        group:  'Group',
        new:    'Nova group',
        add:    'Dodaj group',

        name: 'Ime',
        // D25 — prikazno ime je panelovo, ne Traefikovo. Traefikovo ime je spodnji ključ.
        name_hint:    'Vidno je samo v panelu. V Traefikovo konfiguracijo nikoli ne pride.',
        name_invalid: 'Uporabite največ 64 znakov.',

        key:             'Ključ',
        key_hint:        'Poimenuje router in service, ki ju ta group definira.',
        key_hint_linked: 'Poimenuje router in service, ki ju ta group definira. Predizpolnjen je iz domene, dokler ga ne uredite.',
        // `{'@'}` je vue-i18n **literal**, ne nadomestna vrednost — glej isti komentar v `en.ts`.
        key_invalid:     'Začne se s črko ali številko, nadaljuje s črkami, številkami, „.“, „-“ ali „_“, do 63 znakov. „{\'@\'}“ ni dovoljen — Traefik ga bere kot pripono ponudnika.',
        key_reserved:    'Imena, ki se začnejo s „system-“, so rezervirana za panelove lastne groupe.',

        domain:         'Domena',
        domain_hint:    'Točno eno gostiteljsko ime — router se nanj ujema s Host(`…`). Nadomestni znak ali druga domena zahtevata napredni tip.',
        domain_invalid: 'Vnesite eno gostiteljsko ime, na primer app.example.com. Mednarodno domeno je treba vnesti v obliki xn-- (punycode).',

        destination_url:     'URL cilja',
        destination_hint:    'Edini strežnik, ki mu ta group posreduje promet, na primer http://10.0.0.10:8080. Traefik posreduje poizvedbeni niz iz same zahteve, zato ga tu ne vpisujte.',
        destination_invalid: 'Začnite s http:// ali https:// in navedite gostitelja, brez poizvedbenega niza, fragmenta ali poverilnic.',

        insecure_skip_verify: 'Certifikat cilja',
        insecure_switch:      'Preskoči preverjanje TLS za cilj',
        // §7.8 točka 5, D30 — stikalo se sklicuje na sistemski transport celotne instance in ne
        // ustvari svojega, zato je stikalo in ne obrazec.
        insecure_hint:    'Na voljo samo za cilje https://. Service usmeri na skupni sistemski transport te instance.',
        insecure_cleared: 'Cilj ne uporablja več https://, zato je preskok preverjanja TLS izklopljen. Če se vrnete na cilj https://, ga po potrebi znova vklopite.',

        // §7.4 / D31 — ključ je eno polje, ki poimenuje dve definiciji, zato je njegovo urejanje
        // parno preimenovanje. Shranjevanje ga usmeri skozi dialog za preimenovanje (W8.9).
        paired_rename_title: 'Preimenovanje „{from}“ v „{to}“ premakne dve definiciji',
        paired_rename_hint:  'Ključ poimenuje router in service skupaj, zato se preimenujeta oba hkrati. Shranjevanje najprej odpre dialog za preimenovanje, ki pokaže vsako group, ki jo preimenovanje zadeva, preden je karkoli zapisano.',

        type:  'Tip',
        state: 'Stanje',
        types: {
            simple:   'Preprosta',
            advanced: 'Napredna',
            manual:   'Ročna',
            system:   'Sistemska',
        },
        type_unknown_hint: 'Ta različica panela ne pozna tega tipa groupe. Zavihka z generiranim YAML in s sklici še vedno prikazujeta trenutno stanje groupe.',

        // W8.11 — glej isti komentar v `en.ts`: shranjeni izvorni dokument ni oblike, ki jo piše
        // ta urejevalnik, zato obrazca ne prikažemo.
        source_unreadable:      'Te groupe tukaj ni mogoče urejati',
        source_unreadable_hint: 'Njen shranjeni izvorni dokument ni v obliki, ki jo piše ta urejevalnik, zato obrazca ni — prazen obrazec bi ob prvem shranjevanju prepisal pravo konfiguracijo. Zavihki z generiranim YAML, s sklici in z zgodovino prikazujejo, kaj groupa v resnici vsebuje. To prijavite: pomeni, da je dokument zapisalo nekaj drugega kot ta urejevalnik.',

        enabled:  'Vklopljena',
        disabled: 'Izklopljena',

        system:       'Sistemska',
        system_title: 'Ta group pripada panelu',
        // §7.8 — sistemska group je resnična vrstica, §2.4 pa jo namenoma prikaže: njena imena so
        // rezervirana in sodelujejo pri preverjanju trkov, zato jo mora operater videti.
        system_hint: 'Panel jo prevede iz nastavitev instance in jo prepiše vsakič, ko se te spremenijo, zato je tu ni mogoče urejati. Njena imena so rezervirana in sodelujejo pri preverjanju trkov.',
        system_kinds: {
            redirect:          'sistemsko preusmeritvijo HTTP → HTTPS',
            shared_transports: 'sistemskim skupnim transportom',
            certificates:      'sistemsko groupo za certifikate',
            unknown:           'groupo, ki jo ima v lasti panel',
        },

        validation: {
            ok:       'Veljavna',
            invalid:  'Neveljavna',
            warnings: 'Opozorila',
            unknown:  'Ni preverjena',
        },
        validation_label:         'Preverjanje',
        validation_ok_hint:       'Ta group prestane vse preverbe.',
        validation_errors_hint:   'Napak pri preverjanju: {count}',
        validation_warnings_hint: 'Opozoril: {count}',

        defines:          'Definira',
        definitions_more: '+{count} več',
        version:          'Različica',
        version_label:    'Različica {version}',
        unsaved:          'Neshranjene spremembe',

        search_placeholder: 'Iskanje po imenu ali definiciji',
        search_none:        'Nobena group ne ustreza iskanju.',
        count:              'Prikazanih {shown} od {total}',
        none:               'Ni še nobene groupe',
        none_hint:          'Dodajte groupo in usmerite domeno na cilj. Lokacija spremembo prevzame v nekaj sekundah.',
        none_read_only:     'Ta instanca nima nobene groupe, vi pa imate samo pravico branja.',

        tabs: {
            editor:     'Urejevalnik',
            yaml:       'YAML',
            references: 'Sklici',
            history:    'Zgodovina',
        },

        mode_title: 'Kakšna group je to?',
        // D36 — pretvorbe so enosmerne, zato izbirnik to pove, preden je obrazec izpolnjen.
        mode_hint:  'Izbere se enkrat: groupo je pozneje mogoče pretvoriti preprosta → napredna → ročna, nikoli nazaj.',
        modes: {
            simple:        'Preprosta',
            simple_hint:   'Ena domena, en cilj.',
            advanced:      'Napredna',
            // D61/O-20 — izbirnik omejitev pove vnaprej, ne šele sredi izpolnjevanja obrazca.
            advanced_hint: 'Routerji, servici in middlewari s tipiziranimi obrazci in sestavljalnikom pravil. Karkoli izven te matrike zahteva ročni način.',
            manual:        'Ročna',
            manual_hint:   'YAML, ki ga napišete sami, za vse, česar obrazci ne pokrivajo.',
        },

        // Napredni urejevalnik (§9.4, W8.2/W8.2b): `AdvancedGroupForm`, `RouterCard`, `ServiceCard`,
        // `MiddlewareCard` in `RuleNode`. `name_invalid`/`name_duplicate` si delijo imena routerjev,
        // servicov in middlewarov — vsi trije imenski prostori uveljavljajo isto abecedo
        // (`TraefikConfig.validDefinitionName`).
        advanced: {
            routers_title:     'Routerji',
            add_router:        'Dodaj router',
            routers_none:      'Še ni routerjev',
            routers_none_hint: 'Dodajte router, da ujamete promet in ga pošljete na service.',

            services_title:     'Servici',
            add_service:        'Dodaj service',
            services_none:      'Še ni servicov',
            services_none_hint: 'Dodajte service, da ima router kam posredovati promet.',

            // `{'@'}` — vue-i18n literal, glej komentar pri `group.key_invalid`.
            name_invalid:   'Začne se s črko ali številko, nadaljuje s črkami, številkami, „.“, „-“ ali „_“, do 63 znakov. „{\'@\'}“ ni dovoljen — Traefik ga bere kot pripono ponudnika.',
            name_duplicate: 'Drug router, service ali middleware v tej groupi že uporablja to ime.',

            middlewares_title:     'Middlewari',
            add_middleware:        'Dodaj middleware',
            middlewares_none:      'Še ni middlewarov',
            middlewares_none_hint: 'Dodajte middleware in ga pripnite na router, ali ga povežite v verigo (chain) iz drugega middlewara.',

            router: {
                name:      'Ime',
                name_hint: 'Poimenuje ta router — Traefikovo ime, ne prikazno ime.',
                remove:    'Odstrani router',
                unnamed:   'Neimenovan router',

                service:             'Service',
                service_hint:        'Service, ki mu ta router posreduje ujemajoč promet.',
                service_placeholder: 'Izberite ali vpišite ime servica',

                middlewares:             'Middlewari',
                middlewares_hint:        'Uporabljeni za vsako zahtevo, ki jo ta router ujame, v navedenem vrstnem redu.',
                middlewares_placeholder: 'Izberite ali vpišite ime middlewara',

                entry_points:      'Vstopne točke',
                entry_points_hint: 'Prazno pomeni vsako vstopno točko. Vpišite ime in pritisnite enter, da ga dodate.',

                priority:      'Prioriteta',
                priority_hint: 'Višja zmaga, kadar bi se lahko ujemala oba routerja. Prazno pomeni Traefikovo privzeto vrednost po dolžini pravila.',

                tls:               'Streže preko TLS',
                tls_hint:          'Iz tega naredi HTTPS router.',
                tls_options:       'Možnosti TLS',
                tls_cert_resolver: 'Resolver certifikata',
            },

            rule: {
                title: 'Pravilo',
                hint:  'Na kaj se ta router ujema. Skupine so vedno prikazane v oklepajih, zato AND/OR ni nikoli dvoumen.',

                depth_indicator: '{depth} od {max}',
                depth_hint:      'To pravilo je ugnezdeno tako globoko, kot dovoljuje napredni urejevalnik — poenostavite ga ali preklopite na ročni način za tako oblikovano pravilo.',

                matcher:          'Matcher',
                arg:              'Argument',
                arg_n:            'Argument {n}',
                add_arg:          'Dodaj argument',
                remove_arg:       'Odstrani argument',
                all_of:           'Vsi izmed',
                any_of:           'Kateri koli izmed',
                negate:           'Ne',
                add_condition:    'Dodaj pogoj',
                remove_condition: 'Odstrani pogoj',

                kinds: {
                    matcher: 'Matcher',
                    and:     'AND',
                    or:      'OR',
                    not:     'NOT',
                },

                arg_errors: {
                    backtick: 'Ne sme vsebovati obrnjenega narekovaja (`) — Traefikova skladnja pravil v3 zanj nima izhoda.',
                    hostname: 'Vnesite gostiteljsko ime, na primer app.example.com.',
                    path:     'Začne se z „/“.',
                    regex:    'Vnesite veljaven regularni izraz.',
                    free:     'To polje je obvezno.',
                    method:   'Izberite eno od HTTP metod, ki jih prepozna Traefikov matcher Method.',
                    cidr:     'Vnesite IP naslov ali blok CIDR.',
                },
            },

            service: {
                name:    'Ime',
                remove:  'Odstrani service',
                unnamed: 'Neimenovan service',

                kind:      'Tip',
                kind_hint: 'Kako ta service doseže zaledje.',
                kinds: {
                    loadBalancer: 'Load balancer',
                    weighted:     'Uteženo',
                    mirroring:    'Zrcaljenje',
                    failover:     'Failover',
                },

                servers:            'Strežniki',
                server_placeholder: 'http://10.0.0.10:8080',
                add_server:         'Dodaj strežnik',
                pass_host_header:   'Posreduj glavo Host',

                servers_transport:      'Servers transport',
                servers_transport_hint: 'Prazno pomeni Traefikov privzeti transport.',

                sticky:           'Lepljive seje',
                sticky_hint:      'S piškotkom pripne odjemalca na isti strežnik.',
                sticky_name:      'Ime piškotka',
                sticky_secure:    'Secure',
                sticky_http_only: 'HTTP only',
                sticky_same_site: 'SameSite',
                same_site_none:    'None',
                same_site_lax:     'Lax',
                same_site_strict:  'Strict',
                same_site_invalid: 'Izberite „None“, „Lax“ ali „Strict“.',

                health_check:              'Preverjanje zdravja',
                health_check_hint:         'Aktivno preverjanje, s katerim Traefik izloči nezdrav strežnik iz kroženja.',
                health_check_path:         'Pot',
                health_check_path_invalid: 'Začne se z „/“.',
                health_check_interval:     'Interval',
                health_check_timeout:      'Časovna omejitev',
                duration_invalid:          'Vnesite trajanje, ki ga Traefik razume, na primer „10s“ ali „500ms“.',

                weighted_targets: 'Uteženi cilji',
                add_target:       'Dodaj cilj',
                weight:           'Utež',

                main_service:      'Glavni service',
                main_service_hint: 'Vsaka zahteva gre sem; spodnji zrcali prejmejo le kopijo.',
                mirrors:           'Zrcala',
                add_mirror:        'Dodaj zrcalo',
                percent:           'Odstotek',

                primary:       'Primarni service',
                fallback:      'Nadomestni service',
                failover_same: 'Nadomestni service ne more biti enak primarnemu.',
            },

            // MiddlewareCard (W8.2b, D61): dvanajst tipiziranih obrazcev, `errors` in generični
            // urejevalnik ključ/vrednost. `regex_invalid` si delijo vsa polja z regularnimi izrazi
            // (redirectRegex, stripPrefixRegex, replacePathRegex), namesto da bi ga ponavljali.
            middleware: {
                name:    'Ime',
                remove:  'Odstrani middleware',
                unnamed: 'Neimenovan middleware',

                kind:      'Tip',
                kind_hint: 'Kateri Traefikov middleware je to.',
                kinds: {
                    redirectScheme:   'Preusmeritev sheme',
                    redirectRegex:    'Preusmeritev (regex)',
                    stripPrefix:      'Odstrani predpono',
                    stripPrefixRegex: 'Odstrani predpono (regex)',
                    addPrefix:        'Dodaj predpono',
                    replacePath:      'Zamenjaj pot',
                    replacePathRegex: 'Zamenjaj pot (regex)',
                    headers:          'Glave',
                    basicAuth:        'Basic auth',
                    ipAllowList:      'Seznam dovoljenih IP',
                    rateLimit:        'Omejitev hitrosti',
                    chain:            'Veriga (chain)',
                    errors:           'Strani z napakami',
                    generic:          'Drugo (generično)',
                },

                regex_invalid: 'Vnesite veljaven regularni izraz, največ 256 znakov.',

                redirect_scheme: {
                    scheme:       'Shema',
                    port:         'Vrata',
                    port_hint:    'Prazno pomeni ohranitev vrat iz izvirne zahteve.',
                    port_invalid: 'Vrata so samo številke.',
                    permanent:    'Trajno (301, namesto 302)',
                },

                redirect_regex: {
                    regex:            'Regex',
                    replacement:      'Zamenjava',
                    replacement_hint: 'Traefikova lastna skladnja zamenjave regexa, na primer $1 ali ${1}.',
                    permanent:        'Trajno (301, namesto 302)',
                },

                strip_prefix: {
                    prefixes:         'Predpone',
                    add_prefix:       'Dodaj predpono',
                    force_slash:      'Vsili uvodno poševnico',
                    force_slash_hint: 'Doda „/“ nazaj, če bi odstranitev predpone pustila pot brez nje.',
                },

                strip_prefix_regex: {
                    patterns:    'Vzorci',
                    add_pattern: 'Dodaj vzorec',
                },

                add_prefix: {
                    prefix: 'Predpona',
                },

                replace_path: {
                    path: 'Pot',
                },

                replace_path_regex: {
                    regex:       'Regex',
                    replacement: 'Zamenjava',
                },

                headers: {
                    custom_request_headers:  'Dodatne glave zahteve',
                    custom_response_headers: 'Dodatne glave odgovora',
                    add_header:              'Dodaj glavo',
                    header_name:             'Ime',
                    header_value:            'Vrednost',

                    cors_title:                        'CORS',
                    access_control_allow_credentials:  'Dovoli poverilnice',
                    access_control_allow_headers:      'Dovoljene glave',
                    access_control_allow_methods:      'Dovoljene metode',
                    access_control_allow_origin_list:  'Dovoljeni izvori',
                    access_control_expose_headers:     'Izpostavljene glave',
                    access_control_max_age:            'Najdaljša veljavnost (sekunde)',
                    add_vary_header:                   'Dodaj glavo Vary',

                    security_title:              'Varnostne glave',
                    sts_seconds:                 'HSTS najdaljša veljavnost (sekunde)',
                    sts_include_subdomains:      'HSTS velja tudi za poddomene',
                    sts_preload:                 'HSTS preload',
                    force_sts_header:            'Pošlji HSTS tudi preko navadnega HTTP',
                    frame_deny:                  'Prepovej vgrajevanje (X-Frame-Options: DENY)',
                    custom_frame_options_value:  'Poljubna vrednost X-Frame-Options',
                    content_type_nosniff:        'X-Content-Type-Options: nosniff',
                    browser_xss_filter:          'X-XSS-Protection',
                    content_security_policy:     'Content-Security-Policy',
                    referrer_policy:             'Referrer-Policy',
                    permissions_policy:          'Permissions-Policy',
                },

                basic_auth: {
                    users:             'Uporabniki',
                    users_hint:        'Oblika htpasswd: uporabnik:zgoščeno-geslo.',
                    add_user:          'Dodaj uporabnika',
                    user_invalid:      'Ni oblike „uporabnik:zgoščeno-geslo“ (htpasswd).',
                    realm:             'Realm',
                    remove_header:     'Pred posredovanjem odstrani glavo Authorization',
                    header_field:      'Posreduj uporabniško ime v tej glavi',
                    header_field_hint: 'Prazno pomeni, da se uporabniško ime ne posreduje.',
                },

                ip_strategy: {
                    title:         'Lastna strategija IP',
                    hint:          'Kako se iz zahteve določi naslov IP odjemalca. Pustite izklopljeno za Traefikovo privzeto vrednost.',
                    depth:         'Globina',
                    depth_invalid: 'Globina ni negativna.',
                    excluded_ips:  'Izključeni naslovi',
                },

                ip_allow_list: {
                    source_range:               'Dovoljeni naslovi',
                    add_address:                'Dodaj naslov',
                    reject_status_code:         'Statusna koda zavrnitve',
                    reject_status_code_invalid: 'HTTP statusna koda je med 100 in 599.',
                },

                rate_limit: {
                    average:                'Povprečje (zahtev na obdobje)',
                    average_invalid:        'Povprečje je večje od nič.',
                    period:                 'Obdobje',
                    burst:                  'Sunek (burst)',
                    burst_invalid:          'Sunek ni negativen.',
                    source_criterion_title: 'Kriterij vira',
                    request_header_name:    'Ime glave zahteve',
                    request_host:           'Uporabi gostitelja zahteve namesto IP odjemalca',
                },

                chain: {
                    middlewares:             'Middlewari',
                    middlewares_hint:        'Uporabljeni v navedenem vrstnem redu, poleg vsega drugega, skozi kar je zahteva že šla.',
                    middlewares_placeholder: 'Izberite ali vpišite ime middlewara',
                },

                errors: {
                    status:                'Statusne kode',
                    status_hint:           'Tromestna HTTP statusna koda ali obseg „NNN-NNN“.',
                    add_status:            'Dodaj status',
                    status_invalid:        'Vnesite tromestno HTTP statusno kodo ali obseg „NNN-NNN“.',
                    service:               'Service za stran z napako',
                    service_hint:          'Streže po meri narejeno stran z napako za zgornje statusne kode.',
                    query:                 'Query',
                    query_hint:            'Predloga poti za stran z napako, na primer /{status}.html. Prazno pomeni Traefikovo privzeto vrednost.',
                    status_rewrites:       'Preslikave statusov',
                    add_rewrite:           'Dodaj preslikavo',
                    rewrite_from:          'Iz',
                    rewrite_from_invalid:  'Preslikani status je tromestna HTTP statusna koda.',
                    rewrite_to:            'V',
                    rewrite_to_invalid:    'Preslikani status je med 100 in 599.',
                },

                generic: {
                    type:            'Traefikov tip middlewara',
                    type_hint:       'Ime polja, pod katerim se ta middleware prevede, na primer compress ali inFlightReq.',
                    type_typed:      '„{type}“ ima tipiziran obrazec zgoraj — izberite ga v izbirniku tipa, namesto da ga uporabite še enkrat tukaj.',
                    type_whitespace: 'Ima presledke na začetku ali koncu.',

                    config:      'Konfiguracija',
                    config_hint: 'Drevo ključ/vrednost, preverjeno ob shranjevanju — enaka pravila, kot jih Traefik uporablja za ta tip middlewara.',
                    add_key:     'Dodaj ključ',
                    key_placeholder: 'Ključ',

                    value_type: {
                        string:  'Besedilo',
                        number:  'Število',
                        boolean: 'Da / Ne',
                        null:    'Prazno',
                        array:   'Seznam',
                        object:  'Zemljevid',
                    },
                    array_item:    'Element {n}',
                    add_item:      'Dodaj element',
                    duplicate_key: 'Drug ključ na tej ravni že uporablja to ime.',
                },
            },
        },

        // Ročni urejevalnik (§9.4, W8.2): `AppYamlEditor` je urejevalnik, brez ločenega zavihka z
        // generiranim YAML (`visibleGroupEditorTabs`) — ta dokument je tisto, kar je shranjeno.
        manual: {
            yaml:      'YAML',
            yaml_hint: 'Dokument točno tak, kot ga napišete. Shranjevanje ga ohrani bajt za bajtom, razen žetonov, ki jih dejansko preimenuje kaskada preimenovanja (D35).',

            syntax_error_title: 'To še ni veljaven YAML',
            syntax_error_hint:  'Vrstica {line}, stolpec {col}. Pred shranjevanjem popravite skladnjo.',

            advanced_options: 'Napredne možnosti',

            allow_unknown_fields:      'Dovoli neznana polja',
            allow_unknown_fields_hint: 'Dovoli, da ta dokument uporabi Traefikovo polje, novejše od tistega, ki ga pozna ta panel. Privzeto izklopljeno (§7.6).',

            acknowledge_global_tls:      'Dovoli prevzem privzetih možnosti ali shrambe TLS',
            acknowledge_global_tls_hint: 'Definicija tls.options/default ali tls.stores/default na novo nastavi TLS za celotno instanco. Vklopite le, če je to namerno.',
        },

        // §7.1, §9.4 — YAML se izriše iz prevedenega fragmenta na zahtevo in se nikoli ne shrani.
        yaml_hint:      'Izriše ga strežnik iz prevedene groupe. Samo za branje: group je shranjena kot strukturiran dokument, to pa je tisto, kar iz njega nastane.',
        yaml_none:      'Za izris še ni ničesar',
        yaml_none_hint: 'Osnutek se ni prevedel. Odpravite težave v zavihku urejevalnika in dokument se pojavi tu.',

        preview_pending:     'Preverjanje…',
        preview_unavailable: 'Sprotno preverjanje trenutno ni na voljo. Prikazano je lahko zastarelo — shranjevanje strežnik preveri v vsakem primeru.',

        // Razmejitev iz §7.3, koraka 5, v treh naslovih: kaj uvaja to shranjevanje, kaj je instanca
        // nosila že prej in kaj je zgolj nasvet.
        problems_blocking:     'Te groupe še ni mogoče shraniti',
        problems_pre_existing: 'Na tej instanci je bilo že prej',
        problems_warnings:     'Vredno branja',
        problem_in_group:      'v groupi „{group}“',

        collision: {
            title:      'To ime je že zasedeno',
            // §9.4 — sistemski primer pove, katera funkcija panela ime drži, saj operater groupe,
            // ki jo ima v lasti, ni nikoli odprl in je ne bi znal poiskati.
            system:     '„{name}“ je rezervirano s {feature}.',
            group_name: 'Group z imenom „{name}“ na tej instanci že obstaja.',
            definition: '„{name}“ v {kind} že definira group „{group}“.',
            open_owner: 'Odpri „{group}“',
        },

        definitions_title:      'Definicije, ki jih ta group zaseda',
        definitions_hint:       'Imena, ki jih ima v lasti na tej instanci. Druga group, ki bi zahtevala eno od njih, je zavrnjena, te groupe pa ni mogoče izbrisati, dokler se kdo sklicuje nanjo.',
        definitions_none:       'Ni definicij',
        definitions_none_hint:  'Ta group se prevede v dokument, ki ne definira ničesar.',
        references_title:       'Sklici, ki jih ta group ustvari',
        // `{'@'}internal` — vue-i18n literal, glej komentar pri `group.key_invalid`.
        references_hint:        'Imena, na katera kaže. Vsako se mora razrešiti v definicijo vklopljene groupe, v Traefikov vgrajeni cilj ali v dovoljeni cilj {\'@\'}internal, sicer je shranjevanje zavrnjeno.',
        references_none:        'Ni sklicev',
        references_none_hint:   'Nič v tej groupi ne kaže na ime, definirano drugje.',
        reference_site:         'Mesto',
        reference_site_hint:    'Mesto sklica (R1 … R14) — katero polje konfiguracije drži to ime.',
        // §7.3 — R13 in R14 kažeta v `instances.resolvers`, zato njunega cilja ne definira nobena group.
        reference_resolver_hint: 'certResolver je definiran v static konfiguraciji instance, ne v groupi.',
        reference_owner:        'Nosi ga',
        target_namespace:       'Cilj',
        target_name:            'Ime',
        namespace:              'Namespace',
        definition_name:        'Ime',
        pointer:                'Pot',

        // Vhodna polovica zavihka sklicev (§9.1, W8.9): katere groupe poimenujejo definicije *te*
        // groupe. Ponovno uporabi seznam iz predpreverbe brisanja (§7.5) namesto druge poti, ki bi
        // računala enak odgovor (glej lastni komentar `GroupReferencesTab`).
        inbound_title:          'Sklicujejo se nanjo',
        inbound_hint:           'Druge groupe, ki kažejo na ime, ki ga definira ta group. Dokler se katera od njih sklicuje nanjo, sta brisanje in izklop blokirana.',
        inbound_unsaved_title:  'Trenutno ni česa prikazati',
        inbound_unsaved_hint:   'Ta group še ni shranjena, zato ne definira ničesar, na kar bi se lahko sklicevala druga group.',
        inbound_unavailable:    'Tega seznama trenutno ni bilo mogoče prebrati. Znova odprite ta zavihek.',
        inbound_none:           'Nič se ne sklicuje na to group',
        inbound_none_hint:      'Nobena druga group ne kaže na ime, ki ga definira ta. Izbris ali izklop ne pokvari ničesar drugega.',
        inbound_group:          'Group',
        inbound_target:         'Njeno ime',

        history_title:   'Zgodovina',
        history_unsaved: 'Ta group še ni shranjena, zato nima zgodovine.',

        // Zavihek zgodovine iz §7.7 (W8.10): vsaka različica, primerjava med poljubnima dvema in
        // vrnitev nazaj.
        history: {
            none: 'Še ni različic',

            version_column: 'Različica',
            kind_column:    'Sprememba',
            summary_column: 'Kaj se je zgodilo',

            reverted_from: 'Vrnjeno iz v{version}',

            revert:         'Vrni na to različico',
            revert_title:   'Vrni group',
            // §7.7 — vrnitev predvaja izvor ciljne različice skozi običajen postopek shranjevanja,
            // zato se znova preveri in je lahko zavrnjena enako kot vsako drugo shranjevanje;
            // besedilo to pove, namesto da bi obljubljalo vrnitev, ki vedno uspe.
            revert_confirm: 'Vrnem na različico {version}? To predvaja konfiguracijo te različice skozi običajno shranjevanje. Če je bilo ime, ki ga je uporabljala, medtem zasedeno, je vrnitev zavrnjena — nič se ne prepiše.',

            compare_from: 'Primerjaj od',
            compare_to:   'Primerjaj do',

            // `GroupChangeKind` (`pkg/enums/GroupChangeKind`, §7.7) — zakaj obstaja ena različica.
            kinds: {
                create:    'Ustvarjeno',
                save:      'Shranjeno',
                rename:    'Preimenovano',
                enable:    'Vklopljeno',
                disable:   'Izklopljeno',
                delete:    'Izbrisano',
                restore:   'Obnovljeno',
                revert:    'Vrnjeno',
                rollback:  'Povrnjeno',
                system:    'Sistemska ponovna izgradnja',
                converted: 'Pretvorjeno',
            },
        },

        // Enosmerna pretvorba tipa iz D36 (§6.1, §9.4, W8.11) — nikoli izgubna in nikoli ponujena
        // v obratno smer.
        convert: {
            action:  'Pretvori v {to}',
            button:  'Pretvori',
            title:   'Pretvori group',
            // Edini stavek, ki šteje: poti nazaj ni (D36).
            confirm: 'Pretvorim to group iz {from} v {to}? Tega ni mogoče razveljaviti — group tipa {to} ni mogoče pretvoriti nazaj v {from}. Sama konfiguracija se ne spremeni, spremeni se le urejevalnik, skozi katerega jo urejate.',
            success: 'Pretvorjeno v {to}.',
        },

        // Kaskada preimenovanja iz §7.4/§9.4 — `GroupRenameCascadeDialog` (W8.9): načrt, pregled,
        // potrditev, uveljavitev. `kind` v vsakem od spodnjih ključev je preprosta beseda
        // (`renameKindLabel`) — router, service, middleware … — te ostanejo v angleščini povsod na
        // tem zaslonu, tudi tukaj.
        rename: {
            title: 'Preimenuj {kind} „{from}“ v „{to}“',
            intro: 'Preglejte vsako mesto, ki bi ga to preimenovanje spremenilo. Dokler ne potrdite, ni zapisano nič.',

            // §9.4 — ponudba na strani urejevalnika, kadar shranjevanje blokira le to, da na staro
            // ime še vedno kaže druga konfiguracija. Gumb Shrani, ki je sicer edina pot do dialoga,
            // je v tem primeru onemogočen.
            offer_title:  'Shranjevanje je blokirano, ker druge groupe še kažejo na staro ime',
            offer_hint:   'Preimenovanje definicije tukaj ne posodobi group, ki nanjo kažejo, zato je shranjevanje zavrnjeno. Kaskadno preimenovanje naredi oboje hkrati: preimenuje definicijo in prepiše vsako referenco nanjo, v enem pregledanem koraku.',
            offer_action: 'Preimenuj s kaskado',

            loading_plan: 'Sestavljanje načrta preimenovanja …',
            plan_failed:  'Načrta preimenovanja ni bilo mogoče sestaviti. Zaprite to okno in poskusite znova.',

            // §7.4, korak 5 — načrt se je spremenil med odpiranjem tega okna in potrditvijo.
            stale_notice: 'Ta načrt se je spremenil, odkar ste odprli to okno — na eno od prizadetih group je pristala sprememba. Preglejte osvežen načrt spodaj in znova potrdite.',

            // D31: ključ simple groupe poimenuje njen router in service skupaj.
            paired_title: 'S tem se preimenuje tudi parna definicija',
            paired_line:  '{kind} „{from}“ → „{to}“',

            blocking_title: 'Tega preimenovanja še ni mogoče uveljaviti',

            owner_badge:      'Lastnica',
            formatting_badge: 'Ponovno kodirano',

            column_path:     'Kje',
            column_before:   'Pred',
            column_after:    'Po',
            definition_move: 'Ime definicije',

            show_diff: 'Prikaži razliko dokumenta',
            hide_diff: 'Skrij razliko dokumenta',
            diff_hint: 'Predogled: vsaka pojavitev preimenovanega imena je poudarjena v dokumentu. Uveljavljena sprememba zadene le mesta s seznama zgoraj — nikoli besedila znotraj komentarja.',

            formatting_group_note: 'YAML te groupe ni bilo mogoče popraviti žeton za žetonom, zato bo ponovno kodiran — komentarji in vrstni red ključev ostanejo, prazne vrstice ne.',

            // Privolitveno stikalo iz §7.4/D35, prebrano, preden je gumb za potrditev sploh ponujen.
            formatting_title:   'Te groupe bodo ponovno kodirane',
            formatting_intro:   'Njihovega YAML ni bilo mogoče popraviti žeton za žetonom, zato je ponovno kodiran. Komentarji in vrstni red ključev ostanejo; prazne vrstice ne.',
            formatting_consent: 'Razumem, da bodo te groupe ponovno kodirane',

            // §9.4 — gumb za potrditev pove obseg spremembe.
            confirm_button:         'Preimenuj in posodobi {count} sklic(ev) v {groups} group(ah)',
            confirm_button_pending: 'Potrdi',

            success_published: 'Preimenovano. Objavljeno kot posnetek v{version}; lokacija ga prevzame v nekaj sekundah.',
            success_unchanged: 'Preimenovano. Nič se ni spremenilo, zato posnetek ni bil objavljen.',
        },

        // §7.7 korak 3 — enako shranjevanje ne objavi ničesar, in to je uspeh, ne napaka.
        saved_published: 'Shranjeno. Objavljeno kot snapshot v{version}; lokacija ga prevzame v nekaj sekundah.',
        saved_unchanged: 'Shranjeno. Nič se ni spremenilo, zato nov snapshot ni bil objavljen.',

        not_available:      'Group ni na voljo',
        not_available_hint: 'Ne obstaja ali pa do nje nimate dostopa.',

        // §2.3 preklop in §3.3 brisanje (§7.5, W4.6). Dve povedi nosita celoten model in obe
        // povesta tisto, kar se največkrat narobe razume: izklopljena group ne streže ničesar in
        // **obdrži vsa imena, ki jih zaseda** (D26), izbrisana pa jih sprosti (D37).
        enable:           'Vklopi',
        disable:          'Izklopi',
        enable_confirm:   'Vklopim „{name}“? Njene poti pridejo na lokacijo v približno 15 sekundah.',
        disable_confirm:  'Izklopim „{name}“? Takoj preneha streči. Njena imena ostanejo zasedena, zato jo lahko kadar koli spet vklopite.',
        enabled_success:  'Group je vklopljena.',
        disabled_success: 'Group je izklopljena. Njena imena ostajajo zasedena.',

        delete:         'Izbriši group',
        delete_confirm: 'Izbrišem „{name}“? Sprosti se {count} imen, ki jih zaseda, in prevzame jih lahko druga group.',
        delete_success: 'Group je izbrisana.',

        // §7.5 / §9.4 — zavrnitev, ne potrditev: besedilo pove, kaj je treba popraviti, in ne
        // ponuja nadaljevanja, ker ga ni.
        blocked: {
            delete_title:  'Te group še ni mogoče izbrisati',
            disable_title: 'Te group še ni mogoče izklopiti',
            delete_intro:  'Z brisanjem „{name}“ bi odstranili definicije, na katere kaže druga konfiguracija. Traefik na referenco, ki je ne more razrešiti, odgovori s 404 in ne zavrne nalaganja, zato bi te poti obstajale in ne bi delovale.',
            disable_intro: 'Z izklopom „{name}“ njene definicije izginejo iz objavljene konfiguracije, druga konfiguracija pa nanje še kaže. Traefik na referenco, ki je ne more razrešiti, odgovori s 404 in ne zavrne nalaganja, zato bi te poti obstajale in ne bi delovale.',
            summary:       'Referenc, ki bi ostale brez cilja: {sites}, v {groups} groupah.',
            // Robni primer iz §7.5: veriženje `system-redirect-to-https` je povsem legitimno,
            // group, ki drži to ime, pa operater ne more urejati.
            system_owner: 'To je ena od panelovih lastnih groups ({feature}) in je tu ni mogoče urejati — referenco raje odstranite v svoji group.',
            open_group:   'Odpri „{group}“',
            kept:         'Z izklopom se ne sprosti nič: izklopljena group obdrži vsa imena, ki jih zaseda.',
            next:         'Odstranite te reference ali jih preusmerite, nato poskusite znova.',
        },
    },
    // Zgodovina objav (§2.5, §5, §7.7, §9.1, W9.1): vsaka konfiguracija, ki jo je Traefik prejel v
    // strežbo, podroben pogled na eno od njih in primerjava med poljubnima dvema. "Snapshot" je
    // domenski izraz iz sveta Traefika in ostane v angleščini v obeh jezikih (§9.5); vzrok objave
    // uporablja isti slovar kot `group.history.kinds` (prek `getGroupChangeKind`) namesto drugega
    // slovarja za iste dogodke `GroupChangeKind` — snapshot in group version, ki ga je povzročila,
    // opisujeta isto spremembo v istem jeziku.
    snapshot: {
        history_title: 'Zgodovina objav',
        history_hint:  'Vsaka konfiguracija, ki jo je Traefik prejel v strežbo, v vrstnem redu objave.',

        version_column:     'Različica',
        cause_column:       'Vzrok',
        composition_column: 'Sestava',
        published_column:   'Objavljeno',

        view: 'Prikaži snapshot',
        open: 'Odpri',

        // Isto pravilo kot pri značku sprememb v AppDiffViewer (§9.5): golo število za namigom
        // namesto vstavljenega besedila „{n} groups“ — aplikacija nima nastavljenih pravil za
        // množino, slovenščina pa jih potrebuje štiri, angleščina le dve.
        members_tooltip: 'Groups, vključene v ta snapshot',
        members_none:    'Nič — ne usmerja ničesar',
        by_group:        'iz „{name}“',

        not_found:      'Ta snapshot ni na voljo',
        not_found_hint: 'Na tej instanci ne obstaja, ali pa ga panel trenutno ni mogel prebrati.',

        detail: {
            title: 'Snapshot v{version}',

            content_hash:      'Zgoščena vrednost vsebine',
            size_label:        'Velikost',
            composition_title: 'Sestava',
            // §7.7 — to je cel odgovor na vprašanje, kaj bi povrnil rollback na to različico.
            composition_hint:  'Natančne različice groups, iz katerih je bil sestavljen ta snapshot — kar bi povrnil rollback na to različico.',
            yaml_title:        'Izrisana konfiguracija',
        },

        // §7.7/ADR-0008-jev rollback (W9.2/W9.3) — `SnapshotRollbackDialog`: načrt, pregled,
        // potrditev, izvedba. Razlika v sestavi se izriše v treh razdelkih, `remove` je najglasnejši
        // od treh — edini od njih ni mogoče razveljaviti neposredno iz tega pogovornega okna.
        rollback: {
            action: 'Rollback na to različico',
            title:  'Rollback na snapshot v{version}',
            intro:  'Preglejte natanko, kaj bi to spremenilo, preden je karkoli zapisano. Nič se ne zapiše, dokler ne potrdite.',

            loading_plan: 'Gradim načrt za rollback…',
            plan_failed:  'Načrta za rollback ni bilo mogoče zgraditi. Zaprite to okno in poskusite znova.',

            stale_notice: 'Ta načrt se je spremenil, odkar ste odprli to okno — nekaj se je premaknilo pri eni od prizadetih groups. Preglejte osvežen načrt spodaj in znova potrdite.',

            no_op: 'Ta instanca je že na snapshot v{version}. Rollback nima česa povrniti.',

            revert_title:  'Groups, povrnjene na starejšo različico',
            restore_title: 'Groups, ki bodo obnovljene',
            restore_deleted:  '(izbrisana)',
            restore_disabled: '(onemogočena)',

            // Najglasnejši razdelek — §7.7-ove lastne besede za `remove[]`. Group tu po tem
            // rollbacku ne ohrani nobene sledi svojega obstoja razen lastne zgodovine različic.
            remove_title:    'Groups, ki bodo odstranjene',
            remove_warning:  'Te groups so bile ustvarjene po snapshot v{version} in niso del njegove konfiguracije. Rollback jih mehko izbriše — takoj prenehajo streči promet. Njihova zgodovina ostane ohranjena, zato jih je pozneje mogoče znova obnoviti z rollbackom na različico, ki jih je vključevala.',
            remove_consent:  'Razumem, da bo teh {count} group(s) odstranjenih',

            blocked_title: 'Tega rollbacka še ni mogoče izvesti',
            blocked_line:  '„{key}“ zdaj pripada „{taken_by}“ — v v{version} je pripadal „{group}“',

            blocking_title: 'Ta rollback bi vnesel težave',

            unavailable_certificates_title: 'Enega od certificate iz te različice ni več mogoče dostaviti',
            unavailable_certificates_line:  '„{path}“ — ta certificate je bil od v{version} zamenjan ali izbrisan; njegove stare vsebine ni več nikjer in je ni mogoče ponovno streči',
            unavailable_certificates_hint:  'Sam rollback bo kljub temu uspel, vendar bo Traefik za ta vnos še naprej strežil svoj privzeti certificate — dokler po potrditvi znova ne naložite ustreznega certificate.',

            resulting_yaml_title: 'Rezultat konfiguracije',
            resulting_yaml_hint:  'Kaj bi ta instanca strežla po rollbacku — enako kot lasten dokument snapshot v{version}.',

            confirm_button:         'Izvedi rollback za {count} group(s)',
            confirm_button_pending: 'Potrdi',
            confirm_button_none:    'Ni česa povrniti',

            success_published: 'Rollback na v{version} izveden. Objavljeno kot snapshot v{new_version}; site ga prevzame v nekaj sekundah.',
            success_unchanged: 'Že na v{version}. Nič se ni spremenilo, zato nov snapshot ni bil objavljen.',
        },

        // Obljuba §9.1: primerjava med *poljubnima* dvema objavljenima različicama, ne le
        // sosednjima — operater, ki preiskuje, kdaj se je domena spremenila, seže prav po tem.
        diff: {
            title:        'Primerjava različic',
            hint:         'Izberite kateri koli dve objavljeni različici. Oba dokumenta se izrišeta in primerjata v vašem brskalniku.',
            compare_from: 'Primerjaj od',
            compare_to:   'Primerjaj do',
            need_two:     'Objavite še drugo različico, da jo primerjate s to.',
            load_failed:  'Ene od teh različic ni bilo mogoče naložiti.',
        },
    },
    // Stran registra v skladu panela (§16.1 D74, W16.x): kar panelov lastni register streže
    // agentom, in zrcaljenje, ki ga polni. »Registry«, »tag«, »digest« in »agent« so domenski
    // izrazi sveta registrov in ostanejo v angleščini v obeh jezikih (§9.5), enako kot
    // router/service/middleware — to so besede, ki jih operater vtipka v `docker pull`.
    registry: {
        title:       'Slike agenta',
        description: 'Kar lastni register tega panela streže agentom. Zrcaljenje spodaj vanj kopira slike iz izvornega registra; agenti od tod vlečejo anonimno.',

        // Namensko prazno stanje sentinela RegistryUnavailable — stran poizveduje naprej, zato
        // se to pozdravi samo od sebe, takoj ko vsebnik registra spet odgovori.
        unavailable:      'Register ni odgovoril',
        unavailable_hint: 'Panel po notranjem omrežju ni mogel poizvedeti po svojem registru. Stran samodejno poskuša znova.',

        empty:      'Še ni slik',
        empty_hint: 'Slike se tu pojavijo, ko zrcaljenje prekopira prvi tag iz izvornega registra ali ko je katera potisnjena z gostitelja panela.',

        collected_at: 'zbrano {at}',

        copy_digest:   'Kopiraj digest',
        digest_copied: 'Digest kopiran',
        copy_failed:   'Brskalnik kopiranja ni dovolil. Uporabite namig in digest kopirajte ročno.',

        mirror: {
            title: 'Zrcaljenje',

            status: {
                unconfigured: 'Ni nastavljeno',
                idle:         'V mirovanju',
                syncing:      'Sinhronizira',
                error:        'Napaka',
            },

            // §13.1 — trije ključi so konfiguracija ob postavitvi, nastavljeni tam, kjer je panel
            // nameščen, in namenoma nenastavljivi od tod (poštenost po zgledu fleet_paused_hint).
            unconfigured_hint: 'Zrcaljenje za to postavitev ni nastavljeno. Nastavite REGISTRY_MIRROR_SOURCE, REGISTRY_MIRROR_USERNAME in REGISTRY_MIRROR_TOKEN tam, kjer je panel nameščen, da se slike sem kopirajo samodejno.',

            source:       'Izvorni repozitorij',
            destination:  'Ciljni repozitorij',
            interval:     'Interval sinhronizacije',
            last_sync:    'Zadnja sinhronizacija',
            last_success: 'Zadnja uspešna sinhronizacija',
            last_error:   'Zadnja napaka',

            missing_refs:      'Manjkajoče reference',
            missing_refs_hint: 'Reference, ki naj bi jih flota poganjala, a v izvornem registru še ne obstajajo — viden manko, ne napaka. Zrcaljenje jih preveri ob vsakem prehodu.',

            tags_synced: 'Usklajeni tagi',
            tags_copied: 'Kopirani tagi',
        },

        table: {
            repository: 'Repozitorij',
            tag:        'Tag',
            digest:     'Digest',
            platforms:  'Platforme',
            size:       'Velikost',
            created:    'Ustvarjeno',
        },
    },
    // Skupni besednjak §8.3/§8.4 — ravni dostopa, vrste obsega in vrste virov — uporablja ga
    // `libs/user.ts` in `AccessSourceBadges` v obeh zaslonih preglednosti (M10, W10.5).
    access: {
        level: {
            label: 'Raven dostopa',
            none:  'Brez dostopa',
            read:  'Branje',
            write: 'Pisanje',
        },
        scope: {
            label:    'Obseg',
            client:   'Stranka',
            instance: 'Instanca',
        },
        source: {
            label:              'Viri',
            role_tooltip:       'Dodeljeno prek vloge »{role}«.',
            client_badge:       'Stranka: {name}',
            client_tooltip:     'Dodeljeno na stranki »{name}« ({level}). Velja za vse instance te stranke, vključno s tistimi, dodanimi pozneje.',
            instance_badge:     'Neposredna dodelitev',
            instance_tooltip:   'Dodeljeno neposredno na »{name}« ({level}).',
        },
        no_sources: 'Brez dostopa',
        // §10.4: administrator ali vloga `all_instances:*` doseže celotno floto, zato pogled
        // "od uporabnika naprej" namesto seznama vseh instanc pokaže eno do tri vloge, ki to pojasnijo.
        covers_all_instances: 'To dodeli dostop do vsake instance v floti, vključno s tistimi, dodanimi pozneje.',
    },
    // /users, /users/:userId in /profile (§8, §9.1, W10.3/W10.5). Besednjak vlog in ravni je v
    // razdelku `access` zgoraj; to so besedila, specifična za zaslone uporabnikov.
    users: {
        user:   'Uporabnik',
        name:   'Ime',
        status: 'Stanje',
        active:   'Aktiven',
        disabled: 'Onemogočen',
        you:      'Vi',
        enable:   'Omogoči',
        disable:  'Onemogoči',
        not_available: 'Ta uporabnik ni na voljo. Ne obstaja ali pa do njega nimate dostopa.',
        last_activity: 'Zadnja aktivnost',
        self_notice: 'To je vaš lasten račun. Nihče ne sme urejati lastnih vlog, dodelitev ali stanja tukaj — prosite drugega administratorja.',
        enable_confirm:  'Omogočite »{name}«? Takoj se bo lahko znova prijavil.',
        disable_confirm: 'Onemogočite »{name}«? Ob naslednji zahtevi bo odjavljen in se ne bo mogel prijaviti, dokler ga znova ne omogočite.',
        danger_zone: 'Nevarno območje',
        delete:      'Izbriši uporabnika',
        delete_hint: 'Na voljo je le za uporabnika, ki še nikoli ni imel vloge ali dodelitve — brisanje kogar koli drugega bi izgubilo njegovo revizijsko sled.',
        delete_confirm: 'Izbrišete »{name}«? Tega ni mogoče razveljaviti.',
        roles: {
            title: 'Vloge',
            none:  'Brez vlog',
            admin_locked_hint: 'Vlogo administratorja lahko dodeli ali odvzame samo administrator.',
            last_admin_hint:   'To je zadnji aktivni administrator. Preden mu tukaj odvzamete vlogo, jo dodelite komu drugemu.',
            admin: {
                label:       'Administrator',
                description: 'Polna pooblastila, vključno z upravljanjem uporabnikov in dodeljevanjem vloge administratorja.',
            },
            user_manager: {
                label:       'Upravitelj uporabnikov',
                description: 'Lahko upravlja uporabnike — vloge in dodelitve — a ne pridobi dostopa do nobene instance.',
            },
            all_instances_read: {
                label:       'Vse instance (branje)',
                description: 'Lahko si ogleda vsako instanco Traefika v floti. Ničesar ne more spremeniti.',
            },
            all_instances_write: {
                label:       'Vse instance (pisanje)',
                description: 'Lahko si ogleda in spreminja vsako instanco Traefika v floti.',
            },
        },
        assignments: {
            title: 'Dodelitve',
            none:  'Brez dodelitev z obsegom',
            add:   'Dodaj dodelitev',
            remove: 'Odstrani dodelitev',
            remove_confirm: 'Odstranite to dodelitev na »{name}«?',
            granted_on: 'Dodeljeno {date}',
            pick_client:   'Iščite stranke…',
            pick_instance: 'Iščite instance…',
            client_hint:   'Velja za vse instance te stranke, vključno s tistimi, dodanimi pozneje.',
            instance_hint: 'Velja samo za to eno instanco.',
            pick_from_list:    'Namesto tega izberi s seznama',
            enter_id_manually: 'Namesto tega vnesi ID ročno',
        },
        access: {
            title: 'Dostop',
        },
    },
    // Ovojnici App* za urejevalnik (§9.3). "YAML" je domenski izraz iz sveta Traefika in ostane
    // v angleščini v obeh jezikih, enako kot router/service/middleware (§9.5).
    editor: {
        loading:        'Nalaganje urejevalnika…',
        load_failed:    'Urejevalnika ni bilo mogoče naložiti. Osvežite stran in poskusite znova.',
        yaml:           'YAML',
        read_only:      'Samo za branje',
        view_split:     'Ločeno',
        view_unified:   'Združeno',
        before:         'Prej',
        after:          'Potem',
        no_changes:     'Ni sprememb',
        changed_blocks: 'Spremenjeni bloki',
        // Varovalo velikosti iz W12.5. Namig pove, koliko traja in kaj to stane, ker se odloča
        // operater: to je edino mesto, kjer je ta dokument mogoče prebrati.
        large_diff_title:  'Ta primerjava je velika',
        large_diff_hint:   'Primerjava tako velikih dokumentov traja nekaj časa in med tem zamrzne stran.',
        large_diff_render: 'Vseeno primerjaj',
        large_diff_size:   'Skupna velikost obeh dokumentov',
    },
    errors: {
        generic_error: 'Prišlo je do napake',
        invalid_data:  'Neveljavni podatki',
        not_found:     'Ni najdeno',
        unauthorized:  'Neavtoriziran dostop',
        forbidden:     'Za to dejanje nimate dovoljenja',
        on_add:        'Napaka pri dodajanju',
        on_edit:       'Napaka pri posodabljanju',
        on_delete:     'Napaka pri brisanju',
        on_load:       'Napaka pri nalaganju podatkov',
        // Sentineli iz §6.1, ki jih panel že zna sprožiti.
        name_collision:              'To ime je že zasedeno',
        still_referenced:            'To je še v uporabi in ga ni mogoče izbrisati',
        unsupported_traefik_version: 'Ta različica Traefika je zunaj podprtega razpona',
        // Zavrnitve konfiguracijskega pogona. Podrobnosti nikoli niso v ovojnici (§6.1) — zaslon
        // znova prebere svoj predpreverbeni vir in pokaže seznam, ki jih pojasni.
        reserved_name:            'To ime je rezervirano za panel',
        reference_dangling:       'S tem bi sklic ostal brez cilja',
        invalid_traefik_config:   'Traefik te konfiguracije ne bi sprejel',
        unsupported_yaml_feature: 'Ta zmožnost YAML ni podprta',
        unsupported_section:      'Tega razdelka konfiguracije group ne sme pisati',
        config_too_large:         'Ta konfiguracija je prevelika',
        // §7.4, korak 5 — `GroupRenameCascadeDialog` to sam obravnava tako, da znova izriše osvežen
        // načrt iz ovojnice; to je rezervni izpad za klicatelja, ki tega ne stori.
        rename_plan_stale:        'Ta načrt preimenovanja ni več aktualen',
        // §7.7/ADR-0008 — `SnapshotRollbackDialog` to sam obravnava, enako kot dialog za
        // preimenovanje svoj lasten zastarel načrt: seznam živi na `blocked[]` načrta, to je le
        // rezervni izpad za klicatelja, ki ga je preskočil.
        snapshot_composition_conflict: 'Tega rollbacka ni več mogoče izvesti — ime, ki ga potrebuje, je bilo medtem zasedeno',
        // Trije iz M6 (§6.1). Tisti o driftu ni pritožba, ampak zapora: panel noče prepisati
        // datoteke, ki jo je nekdo spremenil na lokaciji, razliko in revidirano opustitev pa
        // ponuja zavihek static config (§7.10 pravilo 3).
        unknown_dns_provider:    'Tega ponudnika DNS ali nabora poverilnic panel ne more uporabiti',
        static_config_drift:     'Konfiguracijska datoteka na lokaciji je bila spremenjena zunaj panela, zato ni bila prepisana',
        command_not_cancellable: 'Ta ukaz je že prispel na lokacijo in ga ni več mogoče preklicati',
        // §4.5, W9.4 — certifikat in zasebni ključ nista bila uporabna skupaj oz. se ne ujemata.
        invalid_certificate: 'Certifikata in ključa ni bilo mogoče uporabiti skupaj — preverite, ali se zasebni ključ ujema s certifikatom',
        // Varovala upravljanja uporabnikov iz W10.3 (§10.4, D44). `last_admin_removal` je prikazan
        // tudi vgnezdeno, s svojo razlago, ob kontrolniku, ki ga je sprožil (`RolesEditor`, gumb za
        // onemogočanje) — ta splošni stavek je rezervni izpad za obvestilo brez takega kontrolnika.
        self_modification_forbidden: 'Te spremembe ne morete izvesti na lastnem računu — prosite drugega administratorja',
        last_admin_removal:          'S tem bi panel ostal brez administratorja',
        user_has_access_history:     'Ta uporabnik je imel vlogo, dodelitev ali vnos v revizijski sledi in ga ni mogoče izbrisati — namesto tega ga onemogočite',
        // 502 iz D74 — panel deluje, njegov vsebnik registra pa ne odgovarja. `Registry.vue` to
        // izriše kot svoje prazno stanje; ta stavek je rezervni izpad za vsakega drugega klicatelja.
        registry_unavailable:        'Register panela ni odgovoril — poskusite znova čez trenutek',
        site_not_host_networked:     'To mesto je bilo nameščeno pred prehodom na gostiteljsko omrežje, zato ne more uporabiti konfiguracije, ki jo izriše ta panel — na gostitelju znova zaženite namestitveni ukaz s TPM_FORCE=1. Nič ni bilo spremenjeno',
        // Sentinela sejne ravni iz D76. Zavrnitev CSRF je 403, ki ga panel sam nikoli ne povzroči
        // (zahteva z istega izvora dokaze nosi sama) — vzrok je pred panelom, zato je nasvet
        // ponovno nalaganje in nikoli ponovna prijava. Shramba sej je 503: nič ni bilo dodeljeno ali preklicano.
        cross_origin_request:        'Zahteva je bila zavrnjena kot zahteva z drugega izvora. Znova naložite panel in poskusite znova',
        session_store_unavailable:   'Shramba sej ni dosegljiva. Poskusite znova čez trenutek',
    },
    success: {
        add:    'Uspešno dodano',
        edit:   'Uspešno posodobljeno',
        delete: 'Uspešno izbrisano',
    },
    validation: {
        required:  'To polje je obvezno',
        email:     'Neveljaven e-poštni naslov',
        object_id: 'Izberite element s seznama ali vnesite njegov 24-mestni ID',
    },
    table: {
        rows_per_page: 'Vrstic na stran',
        filter:        'Filter',
        clear_filters: 'Počisti filtre',
    },
}
